const swedish = {
  Common: {
    money: '{{amount, currency}}',
    moneyWithTrailingZeros: '{{amount, currency(displayTrailingZeros: true)}}',
    moneyWithoutDecimals: '{{amount, currency(displayDecimals: false)}}',
    termsAndConditionsFairloEverydayLoans: 'Allmänna Villkor Fairlo Varda',
    requiredField: 'Vänligen fyll',
    back: 'Tillbaka',
    cancel: 'Avbryt',
    close: 'Stänga',
    feedback: 'Återkoppling',
    products: {
      credit: 'Varda',
      debtConsolidation: 'Lösa',
      paymentProtectionInsurance: 'Betalskydd',
    },
    contactUs: 'Kontakta kundtjänst',
    loading: 'Läser in',
    shortDate: '{{date, datetime(month: short; day: numeric)}}',
    otpInputLabel: 'Verifieringskod',
  },
  Metadata: {
    title: 'Fairlo, Vardagskredit på dina villkor, livet ska vara fair.',
    description:
      'Låneutrymmen med tydlig effektiv ränta, helt utan avgifter. Ansök när du vill: svaret syns direkt på skärmen!',
  },
  Header: {
    apply: 'Ansök',
    openMenu: 'Öppna meny',
    closeMenu: 'Stäng meny',
    aboutUs: 'Om Fairlo',
    expandYourLoanSpace: 'Levla ditt låneutrymme',
    customerService: 'Kundservice',
    commonQuestions: 'Vanliga frågor',
    login: 'Logga in',

    home: 'Mina Sidor',
    logout: 'Logga ut',
    paymentPlan: 'Betalplan & historik',

    userProfile: 'Min profil',
    cookieSettings: 'Inställningar för cookie',
    paymentProtectionInsurance: 'Fairlo Betalskydd',
    idProtect: 'Fairlo Personskydd',
    toggleContactSupport: 'Växla kontakta support',
    chatWidgetLoadError: 'Chatten är för tillfället inte tillgänglig. Försök igen senare.',
  },
  ApiErrors: {
    bankId:
      'Whoops, BankID signeringen avbröts, försök igen. Om problemet kvarstår vänligen kontakta kundservice@fairlo.se',
    loginTookLong:
      'Whoops, inloggningen dröjde för länge, försök igen. Om problemet kvarstår vänligen kontakta kundservice@fairlo.se',
    somethingWentWrong:
      'Whoops något gick fel, prova gärna igen. Om problemet kvarstår vänligen kontakta kundservice@fairlo.se',
    inactivity:
      'Whoops, du blev utloggad på grund av inaktivitet, logga in igen för att fortsätta. Om problemet kvarstår vänligen kontakta kundservice@fairlo.se',
  },
  fieldErrors: {
    invalidMobile: 'Vänligen fyll i ditt mobilnummer',
    mobileMaxLengthError: 'Vänligen fyll i minst {{length}} nummer',
  },
  Loader: {
    applicationPending:
      'Tryck inte på tillbaka knappen\n\nHäng kvar, vi säkerställer att allt är perfekt och redo för dig. Det kan ta ett par minuter (men antagligen betydligt kortare) så gå ingenstans.',
  },
  Navigation: {
    deposit: 'Återbetala extra',
    withdrawal: 'Gör uttag',
    monthlyPayment: 'Ändra månadsbelopp',
  },
  Button: {
    logInToMyPages: 'Logga in på mina sidor',
    clear: 'Klart',

    save: 'Spara',
    endEverydayCredit: 'Avsluta Fairlo',
    tryAgain: 'Försök igen',
    close: 'Stäng',
  },
  Login: {
    title: 'Logga in på mina sidor.',
    action: 'Logga in',
  },
  CreditAgreementDisclaimer: {
    disclaimer:
      'Vid signering godkänner du: \n<terms>Allmänna Villkoren</terms>, <sekki>SEKKI</sekki>, <creditAgreement>Kreditavtalet</creditAgreement>, samt <directDebit>Autogiromedgivande</directDebit>',
    disclaimerWithPaybackPlan:
      'Vid signering godkänner du: \n<terms>Allmänna Villkoren</terms>, <sekki>SEKKI</sekki>, <creditAgreement>Kreditavtalet</creditAgreement>, <directDebit>Autogiromedgivande</directDebit>, samt <paybackPlan>Initial betalningsplan</paybackPlan>',
  },
  AssessmentFailed: {
    title: 'Hoppsan!',
    text: 'Prova göra om ansökan. Om problemet kvarstår vänligen kontakta <customerServiceMail>kundservice@fairlo.se</customerServiceMail>.',
  },
  SelectAccount: {
    SelectAccountSuccess: {
      heading: 'Du är klar <private>{{userName}}</private>!',
      text: 'Välkommen till din nya liv-händer kreditbuffert. Du kan antingen ta ut det maximala tillgängliga beloppet eller så kan du välja ett specifikt belopp, när det har bekräftats kommer pengarna att överföras direkt till ditt konto.',
      creditLimitLabel: 'Låneutrymme',
      interestRateLabel: 'Ränta:',
      setupFeeLabel: 'Uppläggningsavgift:',
      withdrawalFeeLabel: 'Uttagsavgift (ord. pris {{amount, currency}}):',
      installmentFeeLabel: 'Månadsavgift:',
      myPagesButton: 'Mina Sidor',
      withdrawButton: 'Ta ut pengar',
    },
    SelectAccountError: {
      heading: 'Välj din bank och sedan ditt konto',
      button: 'Försök igen',
    },
  },
  PaymentProvider: {
    willRedirect: 'Snart kommer du att få välja din bank.',
  },

  BisnodeErrorCodes: {
    DR101: 'Adress saknas.',
    DR102: 'Utflyttad.',
    DR103: 'Förvaltare eller förmyndare förordnad.',
    DR104: 'Skyddad identitet.',
    DR105: 'Boxadress.',
    DR106: 'Giltig adress saknas.',
    DR113: 'Förlorad ID-handling.',
    DR209: 'Tidigare eller pågående utmätning.',
    DR210: 'Tidigare eller pågående skuldsanering.',
    DR492: 'Tidigare eller pågående skuldsaldo.',
    DR493: 'Tidigare eller pågående skuldsaldo.',
    DR497: 'Tidigare eller pågående skuldsaldo.',
    DR500: 'Yngre än 20 år.',
    DR501: 'Inflyttad för mindre än 6 månader sedan.',
    DR502: 'Anmärkningar.',
    DR506: 'Taxerad inkomst under 120 000 kr',
  },
  Deposit: {
    description:
      'Ange den summa som du vill återbetala idag, du måste fortfarande betala ditt månadsbelopp även om du gör en extra inbetalning.',
    sliderTitle: 'Dra för att välja belopp:',
    depositButton: 'Amortera {{amount, currency}}',
    maxAmountText:
      'Grattis! Detta betalar av hela din skuld inklusive ränta, totalt {{amount, currency}}, till och med idag. Du behöver inte göra några fler inbetalningar.',
  },
  MonthlyPayment: {
    description: 'Välj det belopp som du vill återbetala varje månad.',
    desktopSliderTitle: 'Dra för att välja vilket månadsbelopp du vill ha:',

    changeMonthlyPaymentButton: 'Ändra till {{amount, currency}}/månad',
  },
  BankAccount: {
    title: 'Anslutet bankkonto',
    changeBankAccount: 'Byt bankkonto',
    addBankAccount: 'Koppla bankkonto',
    bank: 'Bank',
    accountNumber: 'Kontonummer',
    autogiro: 'Autogiro',
    notConnected: 'Ej anslutet',
    updateInProgress: 'Uppdatering pågår',
    connected: 'Anslutet',
  },
  UserProfile: {
    title: 'Min Profil',
    gotoPage: 'Ändra',
    terminatePaymentInsuranceButton: 'Avsluta Betalskydd',
    terminateIdProtectButton: 'Avsluta Personskydd',
    bankAccount: 'Anslutet bankkonto',
    AccountDetails: {
      title: 'Mina uppgifter',
      email: 'E-post',
      mobile: 'Mobilnummer',
      errorToastDuplicateContact:
        'Hoppsan! Verkar som att mailadressen eller telefonnumret du uppgav existerar redan i vårt system. Kontakta kundtjänst för ytterligare hjälp.',
      ocrPrompt: 'För att betala manuellt med OCR använder du nedan uppgifter:',
      ocr: 'OCR',
      ocrBankTransfer: 'Bankgiro',
      ocrDisclaimer: 'Ordinarie månadsbelopp betalas enbart genom autogiro.',
    },
    FinancialDetails: {
      title: 'Min ekonomi',
      monthlyGrossIncomeLabel: 'Total månadsinkomst före skatt',
      houseCostLabel: 'Din boendekostnad per månad',
      transportationCostLabel: 'Din transportkostnad per månad',
      transportationCostInfo: 'Din kostnad för att utnyttja kollektivtrafik samt diverse fordon',
      otherCostLabel: 'Din månadskostnad för ytterligare lån',
      otherLoanCostInfo: 'Din kostnad för övriga lån samt borgensåtaganden.',
      numOfChildrenLabel: 'Antal barn under 18 år i hushållet:',
      adultsLiveWithLabel: 'Antal vuxna över 18 år i hushållet:',
      adultsLiveWithOptionAlone: 'Ensam',
      adultsLiveWithOptionSeveral: 'Flera',
      numberOfChildrenOption0: '0',
      numberOfChildrenOption1: '1',
      numberOfChildrenOption2: '2',
      numberOfChildrenOption3: '3+',
      otherLoanCostPlaceholder: 'Vänligen fyll i dina lånekostnader',
      monthlyHouseCostPlaceholder: 'Vänligen fyll i din boendekostnad',
    },
    termination: {
      reasonPrompt: 'Berätta gärna varför du lämnar oss?',
      formPlaceholder: 'Berätta lite om varför du avslutar så att vi kan lära oss och förbättra oss',
      reasonOption_NO_LONGER_NEEDED: 'Inget behov',
      reasonOption_TOO_EXPENSIVE: 'Räntan är för hög',
      reasonOption_SWITCHED_TO_COMPETITOR: 'Bytt tjänst',
      reasonOption_MISSING_FEATURES: 'Saknar funktioner',
      reasonOption_OTHER_REASON: 'Annan anledning',
    },
  },

  MyCredit: {
    whatDoYouWantToDo: 'Vad vill du göra?',
  },
  Withdrawal: {
    description: 'Välj den summa som du vill föra över till ditt kopplade bankkonto.',
    withdrawAmount: 'Överför {{amount, currency}}',
    desktopSliderTitle: 'Dra för att välja belopp att ta ut:',
  },
  TierMigration: {
    title: 'Ditt uppdaterade avtal',
    text1:
      'När du har signerat kan du göra uttag igen. Den enda skillnaden är en ny årsränta om <b>{{percentage}} %</b>.',
    text2: 'Du behåller som vanligt:',
    li1: 'Fria insättningar',
    li2: 'Anpassa månadsbelopp kostnadsfritt',
    li3: 'Betala enbart ränta för det du nyttjar',
    li4: 'Kreditbelopp {{amount, currency}}',
    button: 'Signera nytt avtal',
  },
  NoActiveCreditPage: {
    title: 'Du verkar inte ha ett aktivt konto hos Fairlo.',
    info: 'Det kan bero på att du har avslutat tjänsten, inte blivit beviljad eller att den har förfallit på grund av obetalda fakturor. Men misströsta ej, det kan vara lätt fixat, klicka på knappen nedanför och ansök igen.',
    button: 'Ansök',
  },
  Modal: {
    OverduePayment: {
      title: 'Betala förfallet belopp',
      info: 'Det totala beloppet att betala in är {{amount, currency}}. Detta inkluderar förfallet månadsbelopp samt eventuella förseningskostnader fram till idag.',
      infoItemTitle: 'Förfallet belopp',
      button: 'Betala {{amount, currency}}',
    },
    OverduePaymentSuccess: {
      title: 'Tack för din betalning',
      info: 'Betalat belopp',
      disclaimer:
        'Observera att om du har en pågående autogirodragning ingår den ej i detta belopp och kommer att dras närmsta dagarna.',
    },
    LevlaOfferSuccess: {
      title: 'Sådärja, då var det klart.',
      info: 'Du kan nu använda din utökade livet-händer-buffert',
      infoItemTitle1: 'Låneutrymme',
      infoItemTitle2: 'Ränta',
    },
    WithdrawalBlocked: {
      title: '<private>{{username}}</private>, du kan tyvärr inte göra uttag just nu',
      info: 'Vi på Fairlo tar sund långivning på allvar och vår bedömning är att det inte vore ansvarsfullt att tillåta fler uttag. Vi kan inte i dagsläget veta när du igen kommer att kunna göra uttag men lovar att meddela dig så fort läget ändras. Tills dess är det superviktigt att du fullföljer din betalningsplan. Dina vänner på Fairlo',
      contactUs: 'Kontakta kundtjänst',
      clear: 'Klart',
    },
    WithdrawalInProgress: {
      title: 'Pengarna är på väg, men det dröjer lite länger än vanligt',
      info: 'Ibland kan transaktioner ta lite längre tid än vanligt. Du bör ha pengarna på ditt konto inom en kvart. Tveka inte att höra av dig till kundservice om du har några frågor.',
      clear: 'Klart',
    },
    WithdrawalAmountInvalid: {
      title: 'Felaktigt belopp',
      info: 'Beloppet du valt att ta ut är inte valbart längre. Vänligen välj ett annat belopp.',
      clear: 'Klart',
    },
    WithdrawalIpAddressCheck: {
      title: 'Vi har noterat förhöjd risk för bedrägeri på ditt konto',
      info: 'För att återställa säkerheten har vi stängt av uttagsfunktionen i tre dagar. Därefter kommer du kunna göra uttag som vanligt igen. Vi förstår att det kan upplevas som stelbent men hoppas att du också uppskattar den höga säkerheten och tackar ödmjukast för ditt tålamod. Tveka inte att höra av dig till kundservice om du har frågor!',
    },
    EmailVerification: {
      title: 'Verifiera din mejl',
      subtitle:
        'Du behöver verifiera din mejl för att fortsätta använda Fairlo som vanligt. Vi kommer skicka en kod till mejlen nedanför.',
      emailLabel: 'E-post',
      submit: 'Gå vidare',
      errorDuplicateEmail:
        'Mejladressen du angav finns redan i vårt system. Kontakta kundtjänst för ytterligare hjälp.',
    },
    EmailVerificationOtp: {
      title: 'Kolla din inbox',
      subtitle: 'Skriv in koden som vi skickat till:',
      resend: 'Beställ ny kod',
      resendWithCountdown: 'Beställ ny kod ({{duration}})',
      codeSent: 'Ny kod skickad!',
      wrongCode: 'Fel kod ({{count}} försök kvar)',
      codeExpired: 'Koden ej giltig längre',
      maxTriesReached: 'Maximalt antal försök uppnått, begär en ny kod',
    },
    EmailVerificationSuccess: {
      title: 'Din mejladress är verifierad!',
      info: 'Allt är klart och du kan nu använda alla funktioner som vanligt.',
      button: 'Klart',
    },
    MobileVerification: {
      title: 'Verifiera ditt telefonnummer',
      subtitle:
        'Du behöver verifiera ditt mobilnummer för att fortsätta använda Fairlo som vanligt. Vi kommer skicka en kod via sms till numret nedanför.',
      mobileLabel: 'Mobilnummer',
      submit: 'Gå vidare',
      errorDuplicateMobile:
        'Mobilnumret du angav finns redan i vårt system. Kontakta kundtjänst för ytterligare hjälp.',
    },
    AgreementHasDebt: {
      title: 'Just nu kan du inte avsluta',
      text: 'Du har en pågående inbetalning som håller på att bearbetas av oss. Under tiden går det inte att avsluta tjänsten. Prova gärna igen om ett par bankdagar, när dragningen är avslutad.',
      button: 'Klart',
    },
    RepayOutstandingBalance: {
      title: 'Du kan inte avsluta just nu!',
      info: 'För att avsluta behöver du först reglera kvarvarande skuld. Det gör du enkelt via Mina Sidor.',
      button: 'Klart',
    },
    LastPaybackStillProcessing: {
      title: 'Du har en kvarvarande skuld',
      info: 'Du kan tyvärr inte avsluta ditt konto just nu eftersom vi för närvarande behandlar din månadsbetalning. Försök gärna igen efter att din betalning har genomförts. Det kan ta upp till en bankdag från att betalning dragits från ditt konto till att den är färdigbehandlad hos oss.',
      button: 'Klart',
    },
    OverdueChargeInProgress: {
      title: 'Just nu kan du inte göra uttag',
      info: 'Du har en försenad betalning som kommer att dras via autogiro kommande dagar. Till dess att det försenade beloppet är betalt kan du inte göra uttag.',
    },
    DirectDebitChargeInProgress: {
      title: 'Du har en pågående autogiro-dragning',
      info: 'För tillfället går det inte att göra uttag under pågående autogiro-dragning. Just nu görs ett dragningsförsök på {{chargeInProgressAmount, currency}}. Så fort din betalning gått igenom kommer du kunna göra uttag som vanligt igen. Tack för ditt tålamod.',
    },
    DirectDebitMandateNotFound: {
      title: 'Just nu kan du inte göra uttag',
      info: 'Ditt autogiro har tagits bort. För att ansöka om att uppgradera din tjänst behöver du aktivera den igen. Välj Anslutet Bankonto i menyn och klicka sedan på Byt konto för att lägga till autogiro, därefter kan du göra uttag igen.',
    },
    DebtConsolidationDirectDebitMandateNotFound: {
      title: 'Just nu kan du inte Lösa fler krediter',
      info: 'Vi saknar ett autogiromedgivande. Vänligen koppla på autogiro igen för att kunna använda tjänsten. Du gör det enkelt genom att klicka på Anslutet Bankonto i menyn och klicka sedan på Byt konto och följ intruktionerna.',
    },
    InsufficientFunds: {
      title: 'Hoppsan, det går inte att ta ut beloppet just nu.',
      info: 'Din senaste betalning har inte hunnit behandlas ännu. Försök igen nästkommande bankdag.',
    },
    DepositSuccess: {
      title: 'Sådär ja, då var allt klart',
      info: 'Du har gjort en amortering. Tack för din betalning.',
      depositAmount: 'Amorterat belopp',
      monthlyAmount: 'Nytt månadsbelopp',
      button: '$t(Button:clear)',
    },
    DepositFail: {
      title: 'Överföringen misslyckades',
      info: 'Transaktionen stoppades av någon anledning. Vänligen försök igen. Om problemet kvarstår kan du höra av dig till vår kundervice.',
    },
    ChangeMonthlyPaymentSuccess: {
      title: 'Sådärja, nytt månadsbelopp!',
      info: 'Nedanför ser du ditt nya månadsbelopp och nuvarande avbetalningsplan.',
      listItemTitle: 'Månadsbelopp',
      numberOfInstallmentsLabel: 'Tidsperiod',
      numberOfInstallmentsValue_one: '{{count}} månad',
      numberOfInstallmentsValue_other: '{{count}} månader',
      button: 'Klart',
    },
    ChangeMonthlyPaymentFailed: {
      title: 'Något blev fel',
      info: 'Det gick inte att ändra din månadsbetalning. Testa igen är du snäll.',
      button: 'Klart',
    },
    BankAccountUpdateInProgress: {
      title: 'Hoppsan, kontot håller på att anslutas',
      info: 'Det tar vanligtvis två vardagar innan autogirot är anslutet. Därefter kan du återigen ändra ditt bankkonto.',
    },
    BankAccountUpdateSuccess: {
      title: 'Sådär ja, då var ditt bankkonto anslutet',
      info: 'Du kan redan nu börja använda tjänsten men autogiro tar oftast några vardagar, ibland längre, innan det är anslutet.',
      button: 'Klart',
    },
    BankAccountUpdateFail: {
      title: 'Det gick inte att ansluta konto!',
      info: 'Det gick inte att ansluta bankkonto och autogiro men försök gärna igen. Behöver du hjälp kan du kontakta oss på kundtjänst.',
    },
    ConfirmWithdrawal: {
      title: 'Vill du göra ett uttag på {{withdrawalAmount, currency}}?',
      info: 'Nedan kan du se ditt nya nyttjade belopp och uppdaterade månadsbelopp.',
      infoWithFees:
        'Nedan ser du ditt uppdaterade månadsbelopp och totalt nyttjad kredit inkl Uppläggningsavgift {{setupFee, currency}} och Uttagsavgift {{withdrawalFee, currency}}.',
      infoTitle1: 'Månadsbelopp i {{numberOfInstallments}} månader',
      infoTitle2: 'Nyttjat belopp',
      button: 'Överför {{withdrawalAmount, currency}}',
    },
    NoRemainingDebtInfo: {
      title: 'Säker på att du vill säga upp ditt avtal?',
      info: 'Du vet väl att Fairlo inte kostar något när den inte används? Om du avslutar ditt avtal så förlorar du tillgången till ditt konto och måste ansöka på nytt.',
      action: 'Avsluta Fairlo',
    },

    PaybackPlanModal: {
      title: 'Din initiala betalningsplan',
      messageBelowTitle1: 'Förmedlad av Fairlo AB (Fairlo) ',
      messageBelowTitle2:
        'Efter att du blivit beviljad krediten kan du när som helst gå in på Mina Sidor och ändra planen efter eget behag helt utan kostnad. Du kan göra det hur många gånger du vill och det börjar gälla direkt. Precis som vi lovat dig.',
      dueDate: 'Förfallodatum',
      interest: 'Ränta',
      amortization: 'Amortering',
      installmentFee: 'Månadsavgift',
      totalToPay: 'Totalt att betala',
      messageBelowTable:
        'Effektiv årsränta blir {{effectiveInterest}} och den nominella {{interest}}. Totalt att betala tillbaka blir {{totalAmount, currency}} varav {{amount, currency}} är amorterat kapital och {{totalCost, currency}} ränta.',
      total: 'Totalt',
    },
    RemainingDebtInfo: {
      title: 'Du har en kvarvarande skuld.',
      creditProduct: 'Fairlo Varda',
      debtConsolidationProduct: 'Fairlo Lösa',
      loanProduct: 'Fairlo Låna',
      info: 'Tråkigt att du lämnar oss men vi hoppas ha kunnat vara ett stöd i din ekonomi och livsstil. Behöver du oss i framtiden finns vi här för dig, på dina villkor!',
      infoSecond:
        'För att avsluta behöver du först reglera kvarvarande skuld. Det gör du enkelt via Mina Sidor. Klicka nedan för att komma dit.',
      action: 'Mina Sidor',
    },
    LoanIdProtectTerminationInGracePeriod: {
      title: 'Allt är återbetalat och vi kan nu avsluta ditt konto.',
      info: 'Eftersom du är inom din 14-dagars ångerperiod samt har återbetalt till fullo så blir alla avgifter för lån och Personskydd borttagna.',
      infoWithRefundedAmount:
        'Du återbetalade dock {{refundedAmount, currency}} för mycket efter att vi tagit bort alla avgifter.\n\nDet överbetalda beloppet kommer att sättas tillbaka in på ditt bankkonto inom 10 arbetsdagar.',
      feedbackInfo: 'Lämna gärna feedback nedan och så avslutar vi ditt konto.',
      button: 'Avsluta Fairlo',
    },
    RemainingDebtInfoLoanIdProtectInGracePeriod: {
      title: 'Du har lite kvar att betala innan du kan avsluta.',
      info1:
        'Klart det är tråkigt att du vill avsluta ditt konto hos Fairlo men vi hoppas att vi har kunnat vara ett stöd i livet och vardagen. Och glöm inte att vi finns här om du får behov av en schysst livet-händer-buffert på dina villkor!',
      info2:
        'Innan vi kan avsluta ditt TryggLån så måste det utbetalade lånet återbetalas. När det är klart så kommer avgifterna att tas bort och kontot avslutas. Du kommer också i samband med detta att förlora tillgång till Fairlo Personskydd.',
      loanIdProtectProduct: 'Fairlo Trygglån',
      button: 'Betala och avsluta',
    },
    RemainingDebtInfoLoanIdProtect: {
      title: 'Du har lite kvar att betala innan du kan avsluta.',
      info1:
        'Klart det är tråkigt att du vill avsluta ditt konto hos Fairlo men vi hoppas att vi har kunnat vara ett stöd i livet och vardagen. Och glöm inte att vi finns här om du får behov av en schysst livet-händer-buffert på dina villkor!',
      info2:
        'Innan du kan avsluta ditt konto så måste du betala tillbaka den sista utestående summan. Det gör du enkelt på Mina Sidor. Klicka nedanför för att komma dit.',
      info3:
        'Fairlo Personskydd är betalt till {{dateValidThrough}} och du har tillgång till tjänsten till det datumet.',
      loanIdProtectProduct: 'Fairlo Trygglån',
      button: 'Mina Sidor',
    },
    LoanIdProtectTermination: {
      title: 'Allt är återbetalat och vi kan nu avsluta ditt konto.',
      info1:
        'Du kommer att ha fortsatt tillgång till Fairlo Personskydd fram t.o.m. {{dateValidThrough}} då du redan har betalat för detta.',
      info2: 'Vi skickar epost med en länk där du kan logga in för att fortsätta nyttja produkten.',
      feedbackInfo: 'Lämna gärna feedback nedan och så avslutar vi ditt konto.',
      button: 'Avsluta Fairlo',
    },
    WithdrawalFail: {
      title: 'Överföringen misslyckades',
      info: 'Transaktionen stoppades av någon anledning. Vänligen försök igen. Om problemet kvarstår kan du höra av dig till vår kundervice.',
      contactUs: 'Kontakta kundtjänst',
      tryAgain: 'Försök igen',
    },
    WithdrawalSuccess: {
      title: 'Pengarna är på väg',
      directPayoutInfo:
        'Dina pengar bör finnas på ditt konto inom några minuter. Glöm inte att du kan ändra din månatliga återbetalning när som helst för att minska din kreditkostnad.',
      info: 'Dina pengar bör finnas på ditt konto senast nästkommande bankdag. Glöm inte att du kan ändra din månatliga återbetalning när som helst för att minska din kreditkostnad.',
      fairnessReceiptButton: 'Visa Fairnesskvitto',
      button: 'Ändra återbetalningsplan',
    },
    LoanWithdrawalSuccess: {
      title: 'Pengarna är på väg',
      body: 'Dina pengar bör finnas på ditt konto inom några minuter. Glöm inte att du kan ändra din månatliga återbetalning när som helst för att minska din kreditkostnad.',
      fairnessReceiptButton: 'Visa Fairnesskvitto',
      button: 'Ändra återbetalningsplan',
    },
    LoanWithdrawalFailed: {
      title: 'Något gick fel så vi lyckades inte betala ut pengarna.',
      body: 'Om problemet kvarstår, vänligen kontakta kundtjänst på <customerServiceMail />',
      button: 'Försök igen',
    },
    DirectPaymentFailed: {
      title: 'Något gick fel…',
      info: 'Testa att fullfölja betalningen igen.',
    },
    PaymentFailed: {
      title: 'Överföringen misslyckades',
      info: 'Transaktionen stoppades av någon anledning. Vänligen försök igen. Om problemet kvarstår kan du höra av dig till vår kundervice.',
    },
    DirectPaymentPaid: {
      title: 'Du har redan betalat',
      info: 'Tack för din betalning',
    },
    DirectPaymentDetails: {
      info: 'Din fakturaspec',
      discountInfo: 'Din fakturaspec. Grön text visar besparingar gjorda efter strukna kostnader.',
    },
    DirectPaymentSuccess: {
      title: 'Swishat!',
      info: 'Tack för din betalning.',
    },
    DirectPaymentNothingToPay: {
      title: 'Det finns inget att betala',
      info: 'Vi hittar inga obetalda fakturor. Logga in på Mina sidor för att se din betalplan.',
    },
    DirectPaymentGenericError: {
      title: 'Något gick fel...',
      info: 'Logga in på mina sidor.',
    },
    WithdrawalNotPossible: {
      title: 'Hoppsan!',
      info: 'För att göra uttag krävs att du har minst {{minimumWithdrawalAmount, currency}} i outnyttjad kredit.',
      button: 'Klart',
    },
    PaymentProtectionInsuranceSuccess: {
      title: 'Toppen, du är nu försäkrad.',
      info: 'Nu kan du känna dig trygg tack vare Fairlo Betalskydd. Du har fått ett välkomstbrev med all information till din epostadress.',
    },
    MigrationToNewTierNeeded: {
      title: 'Uppdatera avtal',
      info: 'För att fortsätta göra uttag behöver du uppdatera ditt kreditavtal. Det tar bara någon minut.',
      readMore: 'Läs mer',
    },
    CreditTierMigrationSuccess: {
      title: 'Sådär ja!',
      info: 'Ditt kreditavtal är uppdaterat och du kan nu göra uttag igen.',
    },
    PaymentFreeMonthWithdrawalBlocked: {
      title: 'Just nu kan du inte göra uttag.',
      info: 'Detta beror på att du har utnyttjat en betalfri månad. Uttag kan tidigast göras 6 månader efter en betalfri månad.',
    },
    ConfirmLeaveCreditOffer: {
      title: 'Vill du ändra något i din ansökan?',
      body: 'Om du går tillbaka behöver du börja om din ansökan från början.',
      button: 'Behåll mitt erbjudande',
    },
    ConfirmTerminatePaymentProtectionInsurance: {
      title: 'Är du säker på att du vill ta bort skyddet?',
      info: 'Om du klickar “Ja, jag är säker” så avslutar vi Fairlo Betalskydd, vilket tar bort skyddet vid till exempel arbetslöshet eller sjukskrivning. Är du säker på att du vill det?',
      button: 'Ja, jag är säker',
    },
    PaymentProtectionInsuranceToBeTerminated: {
      title: 'Så, då var det klart!',
      info: 'Betalskyddet är nu avslutat. Försäkringen gäller fram till månadens slut.',
      button: 'Klart',
    },
    TermsAndConditionsUpdated: {
      title: 'Vi har uppdaterat våra Allmänna Villkor',
      info: 'Du behöver inte göra något, men om du vill kan du klicka på knappen nedan för att läsa den senaste versionen.',
      button1: 'Läs mer',
      button2: 'Klart',
    },
    DirectPaymentOrderNotFound: {
      title: 'Något gick fel...',
      body: 'Vi kunde inte hämta dina obetalda fakturor just nu. Försök igen senare eller kontakta vår kundtjänst för hjälp.',
    },
    ConfirmTerminateIdProtect: {
      title: 'Är du säker på att du vill ta bort skyddet?',
      info: 'Om du klickar på "Ja, jag är säker", kommer vi att avsluta ditt Fairlo Personskydd. Det innebär att du inte längre har skydd mot bedrägeri, identitetsstöld och hackare.',
      validThrough: 'Sista datum som skyddad vid avslut',
      button: 'Ja, jag är säker',
    },
    IdProtectInfo: {
      title: 'Unikt skydd mot bedrägeri, identitetsstöld och hackers',
      cost: 'Kostnaden ({{amount, currency}}) inkluderas räntefritt i din skuld.',
      body: 'Tjänsten bevakar ditt digitala avtryck i email, kortuppgifter, pass med mera samt säkerställer att du ligger steget före potentiella hot.',
      item1:
        '<b>Försäkring</b> som skyddar mot förlust, juridisk hjälp (upp till 1,34 mkr), ID-stöld, SIM-kortsintrång, köp, onlinetrakasserier och psykologstöd.',
      item2:
        '<b>Realtidsbevakning</b> av email, telefon, betalkort, kreditinformation, myndighetsdata, pass, ID-kort, körkort med mera.',
      item3:
        '<b>Supportnummer</b> och andra användbara funktioner som till exempel kreditspärr som förhindrar obehöriga kreditansökningar.',
      button: 'Klart',
    },
    OpenBankingInfo: {
      title: 'Vad är Open Banking och Kreditz?',
      continueWithoutButton: 'Hoppa över',
      continueWithButton: 'Hämta bankdata',
    },
    OpenBankingRecoveryInfo: {
      title: 'Vad är Open Banking och Kreditz?',
      button: 'Hämta bankdata',
    },
    OpenBankingRecoveryCancellation: {
      title: 'Är du säker på att du vill avbryta?',
      description1: 'Du kan inte komma tillbaka till den här ansökan igen, utan behöver ansöka på nytt.',
      description2:
        'Den kreditupplysning vi baserat beslutet på går inte att återta, och du missar din andra chans.',
      goBackButton: 'Nej, ta mig tillbaka',
      confirmButton: 'Ja, avbryt min ansökan',
    },
    OpenBankingExplainer: {
      description:
        'För att ge dig ett lån med schyssta och aktuella villkor behöver vi förstå din nuvarande ekonomi. Därför samarbetar vi med Kreditz, en ledande tjänst för att hämta bankdata på ett säkert sätt.',
      whyKreditzTitle: 'Varför använder vi Kreditz?',
      whyKreditzDescription:
        'Kreditz låter oss hämta information om inkomster och utgifter direkt från din bank. Det ersätter manuella dokument och ger oss en rättvis och uppdaterad bild av din återbetalningsförmåga.',
      benefitsTitle: 'Vad är fördelen för dig?',
      benefit1: 'Bättre beslut: Bedömningen baseras på din faktiska situation just nu.',
      benefit2:
        'Snabbare process: Inga lönebesked eller kontoutdrag att ladda upp. Allt sker automatiskt på några sekunder.',
      benefit3: 'Högre träffsäkerhet: Det hjälper oss att sätta ett lån som passar din budget.',
      safetyTitle: 'Är det säkert?',
      safetyDescription:
        'Ja. Kreditz står under tillsyn av Finansinspektionen och använder samma säkerhetslösningar som storbankerna.',
      safetyPoint1: 'Du legitimerar dig tryggt med BankID.',
      safetyPoint2: 'Endast den data som behövs analyseras och sparas aldrig längre än nödvändigt.',
      safetyPoint3:
        'Kreditz har enbart läsbehörighet. De kan aldrig påverka dina pengar eller se dina inloggningsuppgifter.',
    },
    TerminateIdProtectSuccess: {
      title: 'Ditt personskydd är avslutat',
      info: 'Du har fortfarande tillgång till Fairlo Personskydd till slutet av månaden, då din åtkomst upphör.',
      button: 'Klart',
    },
    IdProtectTerms: {
      title: 'Krav för personskyddet',
    },
    IdProtectSignupSuccess: {
      title: 'Du är skyddad',
      body: 'Snyggt jobbat, Fairlo Personskydd är nu aktiverat. Du kommer att få ett välkomstmail och kan enkelt få tillgång till tjänsten via menyn när du är inloggad.',
      monthlyCost: 'Månadskostnad',
      button: 'Klart',
    },
    ConfirmReactivateIdProtect: {
      title: 'Vill du återaktivera Fairlo Personskydd?',
      body: 'Klicka på knappen nedan för att bekräfta återaktivering av Fairlo Personskydd. Din tillgång till tjänsten kommer då att fortsätta utan avbrott och avgiften kommer att dras varje månad som vanligt.',
      monthlyCost: 'Månadskostnad',
      button: 'Ja, jag är säker',
    },
    IdProtectReactivateSuccess: {
      title: 'Fairlo Personskydd är nu återaktiverat.',
      monthlyCost: 'Månadskostnad',
      button: 'Klart',
    },
    IdProtectCampaign: {
      title: 'Grattis till två månaders kostnadsfritt Personskydd!',
      body: 'Ökad trygghet för dig som kund: Vi bjuder på 2 månaders skydd. Det hjälper dig att omedelbart upptäcka och stoppa bedrägerier, ID-kapningar och digitala hot.',
      costAfter:
        'Därefter blir kostnaden {{amount, currency}}/mån. Avsluta när du vill utan bindningstid på Mina sidor.',
      features: {
        feature1: 'Bred försäkring täcker upp till 1 miljon kronor',
        feature2: '24/7 övervakning av dina personuppgifter',
        feature3: 'Personlig hjälp av experter dygnet runt',
        feature4: 'Snabb blockering vid misstänkt kreditbedrägeri',
      },
      disclaimer:
        'Genom att klicka på "Acceptera erbjudandet" så accepterar du avtalsvillkor för <idProtectTerms>Fairlo Personskydd</idProtectTerms>',
      buttons: {
        decline: 'Nej tack',
        accept: 'Acceptera erbjudandet',
      },
    },
    ConfirmReactivatePaymentProtectionInsurance: {
      title: 'Vill du återaktivera Fairlo Betalskydd?',
      body: 'Klicka på knappen nedan för att bekräfta återaktivering av Fairlo Betalskydd. Din tillgång till tjänsten kommer då att fortsätta utan avbrott och avgiften kommer att dras varje månad som vanligt.',
      monthlyCost: 'Månadskostnad',
      button: 'Ja, jag är säker',
    },
    PaymentProtectionInsuranceReactivateSuccess: {
      title: 'Fairlo Betalskydd är nu återaktiverat.',
      monthlyCost: 'Månadskostnad',
      button: 'Klart',
    },
  },
  Credit: {
    title: 'Fairlo Varda',
    cards: {
      // TODO(EC-1004): Remove once newProductHomepage is fully rolled out
      noBankAccount: {
        title: 'Bankkonto saknas',
        body: 'Klicka här för att ansluta ett bankkonto.',
      },
      // TODO(EC-1004): Remove once newProductHomepage is fully rolled out
      noDirectDebit: {
        title: 'Autogiro saknas',
        body: 'Klicka här för att ansluta ett bankkonto och undvik en onödig avgift på {{amount, currency}} på din nästa faktura.',
      },
    },
    rejections: {
      defaultTitleWithName:
        '<private>{{username}}</private>, vi kan denna gång inte bevilja dig Fairlo Varda.',
      defaultTitle: 'Den här gången kan vi inte bevilja dig någon kredit',
      defaultText:
        'Ansvarsfullt långivande är viktigt för oss. Vi är därför alltid noggranna med att alltid försöka vara så säkra vi kan på att en kredit är rätt för dig. Och den här gången bedömde vi att just vår produkt inte är rätt för just dig just nu. Men saker förändras så prova gärna igen i framtiden!',
      bankIdIssueText:
        'Vi kan just nu inte genomföra en ansökan med det aktuella bankid:et då det är mindre än tio dagar sedan det utfärdades. Detta är en säkerhetsåtgärd från vår sida. Vänligen försök igen senare.',
      numberOfLoansExceededText:
        'Vi är smickrade över att du gillar vår tjänst så mycket! Men vi kan tyvärr inte erbjuda dig en kredit den här gången. Du har tagit 12 lån inom en 12-månadersperiod och därför uppnått maxgränsen för antalet lån. Har du frågor eller funderingar kring detta är du mer än välkommen att höra av dig till vår kundservice.',
      existingCreditTitle: '<private>{{username}}</private>, du har redan en aktiv kredit hos oss.',
      existingCreditText1:
        'Klicka nedan och logga in på mina sidor​ för att se och hantera din kredit. Du kan ändra plan, amortera extra eller avsluta när du vill med ett klick utan kostnad.',
      existingCreditText2:
        'Tveka inte att höra av dig till vår kundservice om du har frågor eller funderingar.',
      overduePaymentsText:
        'Du har obetalda amorteringar från en tidigare kredit. Du behöver betala dessa innan du kan få ut en ny kredit. Hör av dig till vår kundservice om du vill ha hjälp att ordna detta.',
      partnerRejectedTitle: 'Tyvärr kunde vi inte godkänna dig idag.',
      partnerRejectedText: 'Beslutet baseras på en samlad bedömning av din ekonomi.',
      partnerRejectedButton: 'Tillbaks till startsidan',
      terminatedLoanText:
        'Du har sedan tidigare ett förfallet lån hos oss och vi kan därför inte erbjuda dig Fairlo Varda. Vänligen hör av dig till vår kundservice på <customerServiceMail>kundservice@fairlo.se</customerServiceMail> för mer information.',
      userBlockedText:
        'Du är för närvarande spärrad i vårt system. Vänligen hör av dig till vår kundservice för mer information.',
      recentBisnodeCallTitle:
        '<private>{{username}}</private>, den här gången kan vi inte bevilja dig en kredit.',
      recentBisnodeCallText:
        'Du har nyligen ansökt om en kredit hos oss och inte blivit beviljad. För att inte påverka din kreditvärdighet negativt med många ansökningar tillåter vi enbart en ansökan var 90:e dag. Prova att söka igen den {{dateToReapply}}.',
      ucScoreMissingTitle: 'Just nu kan vi inte godkänna din ansökan.',
      ucScoreMissingText:
        'Då UC inte har skickat oss hela din fil kan vi inte behandla din ansökan. Om du har några frågor kring detta, var snäll och kontakta UC.',
      ucServiceErrorTitle: 'Just nu kan vi inte godkänna din ansökan.',
      ucServiceErrorText:
        'På grund av ett tekniskt fel hos UC kunde vi inte inhämta den information vi behöver för att behandla din ansökan. Testa att ansöka igen senare idag. Vid en ny ansökan kan ytterligare kreditupplysningar komma att tas.',
      kalpTitle: 'Den här gången kan vi inte bevilja dig någon kredit',
      kalpText1:
        'Enligt våra beräkningar går kalkylen för “Kvar-att-leva-på” inte ihop. Vi kan därför inte erbjuda dig en kredit för tillfället. Vi har använt oss av de uppgifter du lämnat gällande inkomster och utgifter, samt information från externa källor för att komma fram till vårt beslut.',
      kalpText2:
        'Har du frågor eller funderingar är du mer än välkommen att höra av dig till vår kundservice! Du är så klart även välkommen att försöka igen längre fram.',
      bisnodeTitle: 'Den här gången kan vi inte bevilja dig någon kredit',
      bisnodeText1:
        'Ansvarsfullt långivande är viktigt för oss. Vi är därför alltid noggranna med att alltid försöka vara så säkra vi kan på att en kredit är rätt för dig. Och den här gången bedömde vi att just vår produkt inte är rätt för just dig just nu. Nedan finner du mer info om anledningen bakom vårt beslut:',
      bisnodeText2:
        'Om du har några frågor är du så klart varmt välkommen att kontakta oss via vår kundtjänst.',
      bisnodeText3:
        'Vi hoppas också att du vill komma tillbaka lite längre fram och prova igen. Vi vet att läget förändras!',
      existingLoanTitle: 'Hej <private>{{username}}</private>',
      existingLoanText1:
        'I och med att du har vår låneprodukt Fairlo Låna istället för vår kreditprodukt Fairlo Varda så kan du inte ansöka om höjd kreditgräns.',
      existingLoanText2: 'Ah, just det, så du vet så gjordes ingen kreditkoll för att skapa detta svar.',
      existingLoanButton: 'Till Mina Sidor',
    },
    nordiskaRejection: {
      title: 'Attans, det gick inte igenom den här gången.',
      body: 'Din ansökan klarade inte sista kontrollen och vi kan dessvärre inte erbjuda dig en kredit. Vi förstår att det kan kännas frustrerande men vi måste enligt lag följa dessa regler. Tack för att du tog dig tid att ansöka om kredit hos oss, det är inget vi tar för givet.',
      button: 'Jag fattar, det är lugnt',
    },
  },
  Levla: {
    rejections: {
      defaultTitle: 'Just nu kan du inte Levla',
      defaultText1:
        'Tyvärr uppfyllde inte din ansökan våra krav för att vi ska kunna låta dig att levla upp din kredit. För att kunna levla behöver du ha skött dina lån och krediter samt att ha en god kreditvärdighet enligt kreditupplysning.',
      defaultText2: 'Du kan självklart fortfarande använda din Varda kredit som tidigare.',
      defaultButton: 'Logga in på mina sidor',
      overduePaymentsTitle: 'Vi kan inte utöka ditt låneutrymme just nu.',
      overduePaymentsText1:
        'Du har ett låneutrymme hos oss som tyvärr har minst en förfallen amortering. För att vi ska kunna utöka ditt låneutrymme behöver du först betala det förfallna beloppet. Klicka på knappen nedan eller logga in på mina sidor för att betala.',
      overduePaymentsText2:
        'Tveka inte att höra av dig till <customerServiceMail /> om du har några frågor eller funderingar.',
      overduePaymentsButton: 'Betala det förfallna beloppet',
      maxProductOrEligibilityCheckerRejectedTitle: 'Just nu kan du inte Levla',
      maxProductOrEligibilityCheckerRejectedText1:
        'Vi kan för tillfället inte erbjuda dig högre kreditgräns än den du redan har. Det kan bero på lite olika anledningar, till exempel att du kanske redan har vårt mest fördelaktiga produkt.',
      maxProductOrEligibilityCheckerRejectedText2:
        'Detta påverkar inte din nuvarande livet-händer-buffert. Tveka inte att höra av dig till <customerServiceMail>kundservice@fairlo.se</customerServiceMail> om du har några frågor eller funderingar.',
      directDebitMandateNotFoundTitle: 'Du behöver aktivera autogiro för att Levla.',
      directDebitMandateNotFoundText:
        'Ditt autogiro har tagits bort. För att ansöka om att uppgradera din tjänst behöver du aktivera ditt autogiro igen. Klicka nedan för att gå in på <bankAccountLink>bankkonto</bankAccountLink> och välj sedan "Byt konto" för att lägga till autogiro, därefter kan du ansöka om att levla igen. Lycka till!',
      directDebitMandateNotFoundButton: 'Anslutet bankkonto',
      tooManyInquiriesTitle: 'Just nu kan du inte Levla',
      tooManyInquiriesText1:
        'Just nu har du lite för många färska Bisnode-förfrågningar, så du behöver avvakta med din ansöka. Prova gärna igen lite längre fram.',
      tooManyInquiriesText2:
        '<levlaApplyLink>Här</levlaApplyLink> kan du läsa mer om vad som krävs för att levla.',
      tooManyInquiriesText3:
        'Tveka inte på att höra av dig till <customerServiceMail /> om du har några funderingar.',
      tooManyInquiriesButton: 'Logga in på mina sidor',
      recentBisnodeCallTitle: '<private>{{username}}</private>, vi kan inte öka ditt låneutrymme just nu.',
      recentBisnodeCallText1:
        'Du har nyligen ansökt om utökat kreditutrymme och inte blivit beviljad. För att inte påverka din kreditvärdighet negativt med många ansökningar tillåter vi enbart en ansökan var 90:e dag. Prova att ansöka igen den {{dateToReapply}}.',
      ongoingChargeTitle: 'Just nu kan du inte Levla',
      ongoingChargeText1:
        'Vi kan tyvärr inte behandla din ansökan just nu eftersom den skickades in under betalningsändringsperioden. Under denna tid kan vi inte garantera att betalningar går igenom som förväntat. Försök gärna igen när perioden är över.',
      recentPaymentFreeMonthTitle: 'Just nu kan du inte Levla.',
      recentPaymentFreeMonthText1:
        'Detta beror på att du har utnyttjat en betalfri månad. Du kan tidigast Levla 6 månader (180 dagar) efter en betalfri månad.',
      recentPaymentFreeMonthText2:
        'Tveka inte att höra av dig till <customerServiceMail>kundservice@fairlo.se</customerServiceMail> om du har några frågor eller funderingar.',
      addonProductsSection: {
        title: 'Dina nya aktiva tjänster:',
        description:
          'Du har nu bättre skydd än tidigare, grattis! Vill du ändra eller ta bort dina nya tilläggstjänster går du enkelt till <userProfileLink>Min Profil</userProfileLink>.',
        paymentProtectionInsurance: 'Fairlo Betalskydd',
        idProtect: 'Fairlo Personskydd',
        activated: 'Aktiverad',
      },
    },
    offer: {
      title: 'Du är beviljad en utökad kredit med {{creditLimitDifference, currency}}',
      before: 'Innan',
      after: 'Efter',
      creditAmountUsed: 'Använt saldo',
      interestRate: 'Nominell ränta',
      maxInstallments: 'Maxlängd',
      installmentAmount: 'Månadsbelopp',
      totalCost: 'Total kostnad',
      installmentsPerMonth: '{{numberOfInstallments}} mån',
      text1:
        'Vi erbjuder dig ett utökat kreditutrymme med ytterligare {{creditLimitDifference, currency}} vilket ökar ditt total utrymme till <span>{{offeredCreditLimit, currency}}</span> med en sänkt ränta på <span>{{offeredInterestRate}}</span>.',
      text2: 'Jämför före och efter nedan',
      bottomText1:
        'En uppläggningsavgift på {{setupFee, currency}} läggs till på din totala kredit och en månadsavgift om {{installmentFee, currency}} kommer att tas ut. Dessa avgifter är medräknade i “efter uppgradering” ovan.',
      bottomText2: 'Efter uppgradering till nya villkoren kan man inte gå tillbaka till föregående villkor.',
      button: 'Signera nytt avtal',
    },
    levlaCard: {
      title: 'Ansök om utökad kreditgräns och lägre ränta',
      body: 'Vi bedömer att du har god chans att bli beviljad förbättrade villkor. Klicka här för att läsa mer och ansöka.',
    },
  },
  ErrorInfo: {
    title: 'Oj, något gick fel.',
    text: 'Gå tillbaka, försök igen och om problemet kvarstår kontakta kundtjänst.',
    button: 'Tillbaka till hemsidan',
  },
  LevlaApply: {
    title: 'Ansök om utökat kreditutrymme',
    text: 'Nu kan du ansöka om att Levla upp din livet-händer-buffert hos Fairlo.\n\nOm du blir beviljad får du:',
    uspReducedInterestRate: 'Schysst ränta på {{interestRate}}',
    uspFreeFirstWithdrawal: 'Första uttaget gratis (ord. {{withdrawalFee, currency}})',
    uspFlexible: 'En superflexibel tjänst',
    uspIncreasedCreditLimit: 'Utökat kreditutrymme på {{creditLimit, currency}}',
    disclaimer: 'Vi gör enbart en kreditupplysning från <b>Dun & Bradstreet</b> (tidigare <b>Bisnode</b>)',
    button: 'Ansök nu',
  },
  Products: {
    label: 'Fairlo Produkter',
    menu: {
      myCredit: 'Varda',
      debtConsolidation: {
        label: 'Lösa',
      },
    },
    cards: {
      // TODO(EC-1004): Remove once newProductHomepage is fully rolled out
      usageSummary: {
        total: 'Låneutrymme:',
        used: 'Nyttjat:',
        monthlyAmount: 'Månadsbelopp:',
        monthlyAmountDetails: '{{amount, currency}} i {{period}} mån',
        interest: 'Ränta:',
        nextChargeLabel: 'Nästa dragning:',
        nextChargeDate: '{{chargeDate, datetime(month: short; day: numeric)}}',
        nextChargeOngoing: 'pågående',
      },
      // TODO(EC-1004): Remove once newProductHomepage is fully rolled out
      credit: {
        title: 'Fairlo Varda',
      },
      // TODO(EC-1004): Remove once newProductHomepage is fully rolled out
      debtConsolidation: {
        title: 'Fairlo Lösa',
        bodyInactive: 'Lös dyra krediter och flytta dem till Fairlo med ett klick.',
      },
      // TODO(EC-1004): Remove once newProductHomepage is fully rolled out
      overdue: {
        title: 'Du har ett förfallet belopp',
        body: 'Betala {{amount, currency}} för att undvika fler kostnader och återaktivera tjänsten.',
      },
      // TODO(EC-1004): Remove once newProductHomepage is fully rolled out
      paymentFreeMonth: {
        title: 'Betalfri månad',
        body: 'Du har fått en betalfri månad och kan nyttja din kredit igen efter din nästa månadsbetalning {{nextRepaymentDate}}',
        chargePeriodBody:
          'Du har fått en betalfri månad och kan nyttja din kredit igen efter att din pågående dragning lyckats.',
      },
      // TODO(EC-1004): Remove once newProductHomepage is fully rolled out
      paymentProviderMigration: {
        title: 'Vi har en ny betalleverantör',
        body: 'Vi har en ny betalleverantör. Uppdatera ditt bankkonto för att fortsätta använda tjänsten.',
      },
      resetPaybackPlan: {
        title: 'Stryk dina skulder och börja om på nytt.',
        body: 'Du har ett unikt erbjudande gällande din förfallna faktura, klicka här för att ta del av erbjudandet.',
      },
      // TODO(EC-1004): Remove once newProductHomepage is fully rolled out
      transactionPending: {
        title: 'Transaktion pågår',
        body: 'Vänta någon minut för att göra nya uttag, insättningar och ändra månadsbelopp.',
      },
      // TODO(EC-1004): Remove once newProductHomepage is fully rolled out
      transactionDelayed: {
        title: 'Kontakt med banken dröjer',
        body: 'Vi bevakar tjänsten kontinuerligt. Försök igen om 30 minuter.',
      },
      paymentProtectionInsuranceCard: {
        title: 'Du saknar just nu Betalskydd',
        body: 'Öka din trygghet med vårt generösa betalskydd. Försäkringen betalar ditt Fairlo månadsbelopp i upp till 12 mån vid betalningssvårigheter. Läs mer här.',
      },
      // TODO(EC-1004): Remove once newProductHomepage is fully rolled out
      directDebitMandateInProgress: {
        title: 'Ditt autogiro är snart upplagt',
        body: 'Uppsättning av ditt autogiro pågår. Det kan ta flera bankdagar innan den är aktiverad.',
      },
      idProtectCard: {
        title: 'Var trygg med nya Fairlo Personskydd',
        body: 'Läs mer om vår helt nya tjänst Fairlo Personskydd som erbjuder unikt skydd mot bedrägeri, ID-stöld och hackers.',
      },
      idProtectCampaignCard: {
        title: 'Gratis Personskydd! Titta här.',
        body: 'Du har möjlighet att få 2 månaders gratis Personskydd, klicka här för att ta del av erbjudandet och aktivera ditt skydd.',
      },
      // TODO(EC-1004): Remove once newProductHomepage is fully rolled out
      idProtectActivationNeeded: {
        title: 'Slutföra konfigureringen av Fairlo Personskydd',
        body: 'Klicka här för att logga in på Fairlo Personskydd och slutföra konfigureringen av ditt konto.',
      },
    },
    features: {
      spinWheel: 'Snurra på hjulet för att välja belopp',
    },
    featureDetails: {
      setupFee: 'Uppläggningsavgift {{amount, currency}}',
      withdrawalFee: 'Uttagsavgift {{amount, currency}}',
      withdrawalFeeZero: 'Uttagsavgift {{amount, currency}} (ord {{regularPrice, currency}})',
      principalLeftLabel: 'Nytt saldo:',
      principalLeftDetails: '{{principalLeft, currency}}',
      principalLeftDetailsWithFees: '{{principalLeft, currency}} inkl. avgifter',
      monthlyRepaymentLabel: 'Nytt månadsbelopp, ränta {{percentage}}:',
      monthlyRepaymentDetails: '{{monthlyAmount, currency}} i {{period}} månader',
      totalRepayableLabel: 'Totalt belopp:',
      infoText: 'Du kan enkelt sänka den totala kostnaden genom att höja månadsbeloppet',
    },
  },
  DebtConsolidation: {
    title: 'Fairlo Lösa',
    transfer: {
      disabled: {
        heading: 'Hej <private>{{userName}}</private>,',
        text: 'Vi har valt att tills vidare stänga av funktionen som tillåter dig lösa krediter och lån. Du kan fortfarande ändra ditt månadsbelopp och betala extra.',
      },
    },
    menu: {
      title: 'Vad vill du göra?',
      deposit: 'Återbetala extra',
      monthlyPayment: 'Ändra månadsbelopp',
      additionalDebtTransfer: 'Lösa fler krediter',
    },
  },
  FormErrors: {
    required: 'Vänligen fyll',
    positiveOnly: 'Kan bara bestå av siffor och måste vara större än noll',
    invalidEmail: 'Vänligen fyll i en giltig e-postadress',
    emailTypo: 'Menade du <suggestion>{{suggestion}}</suggestion>?',
    invalidCurrency: 'Måste bestå av siffror',
    maxAmount: 'Vänligen kontrollera värdet',
    invalidNationalNumber: 'Ange personnummer med 10 eller 12 siffror, med eller utan bindestreck.',
    invalidBirthYear: 'Fel år',
    maxLength: 'Vänligen fyll i {{length}} antal bokstäver',
    somethingWentWrong: 'Något gick fel, försök igen',
  },
  PaymentProtectionInsuranceApplicationCard: {
    title: 'Fairlo Betalskydd',
    description: 'Vi betalar din månadskostnad i upp till 12 månader om du skulle råka ut för:',
    features: ['Ofrivillig arbetslöshet', 'Sjukskrivning', 'Sjukhusvistelse', 'Dödsfall vid olycka'],
    cost: 'Från {{amount, currency(displayTrailingZeros: true)}}/mån',
    costDisclaimer:
      'Priset baseras på {{percentage}} av din utestående skuld per månad (aldrig mer än {{maxAmount, currency}}).',
    moreInformation: 'Mer information',
    removeProtection: 'Ta bort skydd',
    addProtection: 'Lägg till Betalskydd',
  },
  IdProtectApplicationCard: {
    title: 'Fairlo Personskydd',
    description:
      'Ökad trygghet för dig som kund, vårt skydd hjälper dig att omedelbart upptäcka och stoppa bedrägerier, ID-kapningar och digitala hot.',
    features: [
      'Försäkring upp till 1 miljon kr',
      'Bevakning av personuppgifter 24/7',
      'Personlig experthjälp dygnet runt',
      'Snabb spärr vid kreditbedrägeri',
    ],
    cost: '{{amount, currency(displayTrailingZeros: true)}}/mån',
    costDisclaimer: 'Ingen bindningstid, avsluta när du vill.',
    moreInformation: 'Mer information',
    removeProtection: 'Ta bort skydd',
    addProtection: 'Lägg till Personskydd',
  },
  AddonProductsDisclaimer: {
    defaultDisclaimer:
      'Genom att klicka på knappen nedan bekräftar du att du inte vill lägga till en skyddstjänst',
    paymentProtectionInsuranceDisclaimer:
      'Genom att klicka “Ja, jag vill ha Fairlo Betalskydd” så accepterar du avtalsvillkor för <terms>Fairlo Betalskydd</terms>',
    idProtectDisclaimer:
      'Genom att klicka “Ja, jag vill ha Fairlo Personskydd” så accepterar du avtalsvillkor för <terms>Fairlo Personskydd</terms>',
    allAddonProductsDisclaimer:
      'Genom att klicka på knappen nedan bekräftar du avtalsvillkor för de valda skydden (<paymentProtectionInsurance>Betalskydd</paymentProtectionInsurance> och <idProtect>Personskydd</idProtect>)',
  },
  ApplicationSE: {
    errorToastMessage:
      'Din ansökan kunde inte gå vidare till nästa steg. Prova igen. Om problemet kvarstår – kontakta vår kundtjänst.',
    errorToastConflict:
      'Tyvärr, vi kunde inte behandla din ansökan just nu. Ladda om sidan och försök igen om 5 minuter.',
    errorToastUserBlocked:
      'Din ansökan är just nu blockerad. Var snäll och kontakta kundtjänst för ytterligare hjälp.',
    intro: {
      title: 'En snäppet schysstare livet-händer-buffert.',
      introText:
        'Ta ut upp till din kreditgräns när som helst och betala endast ränta på det belopp du använder för den tid du använder det.',
      li1: 'Krediter upp till {{amount, currency}}',
      li2: 'Ingen bindningstid, lös lånet när du vill',
      li3: 'Ingen UC - vi använder Dun & Bradstreet',
      li4: 'Första uttaget är kostnadsfritt',
      feesInfoLink: 'Info om avgifter, räntor och återbetalningar.',
      button: 'Ansök nu',
      reviewCard: {
        trustpilotCaption: 'Trustscore',
        googleCaption: 'Average rating of',
        reviews: 'reviews',
      },
    },
    personalDetailsForm: {
      title: 'Lite uppgifter om dig',
      emailLabel: 'E-post',
      emailPlaceholder: 'Fyll i din e-postadress',
      mobileLabel: 'Mobilnummer',
      mobilePlaceholder: 'Måste vara ett giltigt mobilnummer',
      nationalNumberLabel: 'Personnummer',
      nationalNumberPlaceholder: 'YYYYMMDDXXXX',
      submitButton: 'Fortsätt',
      loginButton: 'Redan kund? Logga in här',
      legalText:
        'Genom att fortsätta förstår jag att mina uppgifter kan användas enligt <privacyPolicy>Integritetspolicy</privacyPolicy>.',
    },
    employmentStatusForm: {
      title: 'Din anställningstyp',
      optionUnemployed: 'Arbetslös',
      optionStudent: 'Student',
      optionEmployed: 'Fast anställd',
      optionRetired: 'Pensionär/sjukpensionär',
      optionSelfEmployed: 'Egen företagare',
      optionTemporarilyEmployed: 'Vikarie/projektanställd',
      submitButton: 'Fortsätt',
    },
    livingForm: {
      title: 'Din boende situation',
      housingTypeOptionRENTAL_APARTMENT: 'Hyresrätt',
      housingTypeOptionOWNED_APARTMENT: 'Bostadsrätt',
      housingTypeOptionOWNED_HOUSE: 'Villa eller radhus',
      housingTypeOptionLODGER: 'Inneboende',
      numberOfChildrenLegend: 'Antal barn i hushållet',
      numberOfChildrenOption0: '0',
      numberOfChildrenOption1: '1',
      numberOfChildrenOption2: '2',
      numberOfChildrenOption3: '3+',
      numberOfPersonsLivingLegend: 'Antal vuxna över 18 år i hushållet',
      numberOfPersonsLivingOptionAlone: 'Ensam',
      numberOfPersonsLivingOptionSeveral: 'Flera',
      submitButton: 'Fortsätt',
    },
    loanPurposeForm: {
      title: 'Ange syftet med lånet',
      optionCONSUMPTION: 'Konsumtion, Vardagsutgifter & Övrigt',
      optionVEHICLE_AND_TRANSPORT: 'Fordon & Transport',
      optionRENOVATION_AND_HOUSING: 'Renovering & Bostad',
      optionDEBT_CONSOLIDATION: 'Samla Lån & Refinansiering',
      submitButton: 'Fortsätt',
    },
    financesForm: {
      title: 'Din ekonomi',
      monthlyGrossIncomeLabel: 'Din totala månadsinkomst före skatt',
      monthlyGrossIncomePlaceholder: 'Måste vara större än noll kr',
      monthlyHouseCostLabel: 'Din boendekostnad per månad',
      monthlyHouseCostPlaceholder: 'Vänligen fyll i din boendekostnad',
      transportationCostLabel: 'Din transportkostnad per månad',
      transportationCostInfo: 'Din kostnad för att utnyttja kollektivtrafik samt diverse fordon',
      otherLoanCostLabel: 'Din månadskostnad för ytterligare lån',
      otherLoanCostPlaceholder: 'Vänligen fyll i dina lånekostnader',
      otherLoanCostInfo: 'Din kostnad för övriga lån samt borgensåtaganden.',
      disclaimer: 'Jag godkänner att min ansökan \nbehandlas enligt <terms>Allmänna villkor</terms>.',
      submitButton: 'Gå vidare med ansökan',
    },
    openBankingChoice: {
      title: 'Ökad chans till godkännande eller högre kreditgräns',
      description:
        'En kreditupplysning visar inte alltid hur din ekonomi ser ut idag. Dela information från ditt lönekonto så kan vi även ta hänsyn till aktuella inkomster och utgifter.',
      benefit1: 'Tar cirka 2 minuter',
      benefit2: 'Inga pengar kan flyttas',
      benefit3: 'Säker anslutning via Kreditz',
      benefit4: 'Uppgifterna används bara för kreditbedömningen',
      learnMoreLink: 'Så hanteras din kontoinformation',
      continueWithoutButton: 'Hoppa över',
      continueWithButton: 'Dela kontoinformation',
    },
    openBankingVerification: {
      title: 'För att slutföra din ansökan behöver vi verifiera din ekonomi',
      description:
        'Det här steget krävs för att vi ska kunna slutföra kreditbedömningen. Genom att dela information från ditt lönekonto kan vi ta hänsyn till dina aktuella inkomster och utgifter.',
      benefit1: 'Tar cirka 2 minuter med BankID',
      benefit2: 'Säker anslutning via Kreditz',
      benefit3: 'Endast läsbehörighet – inga pengar kan flyttas',
      learnMoreLink: 'Så hanteras din kontoinformation',
      connectButton: 'Dela kontoinformation',
      cancelButton: 'Avsluta ansökan',
    },
    openBankingRecovery: {
      title: 'Ge din ansökan en ny chans',
      description:
        'Vi kunde inte godkänna din ansökan utifrån kreditupplysningen. Den visar inte alltid hur din ekonomi ser ut idag. Genom att dela information från ditt lönekonto kan vi även ta hänsyn till aktuella inkomster och utgifter och göra en ny bedömning.',
      benefit1: 'Ingen ny kreditupplysning tas',
      benefit2: 'Tar cirka 2 minuter med BankID',
      benefit3: 'Säker anslutning via Kreditz – inga pengar kan flyttas',
      learnMoreLink: 'Så hanteras din kontoinformation',
      cancelButton: 'Avsluta ansökan',
      primaryButton: 'Dela kontoinformation',
    },
    openBankingConnection: {
      iframeTitle: 'Open Banking anslutning',
    },
    openBankingLoader: {
      fetching: {
        spinnerLabel: 'Hämtar bankdata...',
        title: 'Vi hämtar dina uppgifter',
        description:
          'Vi ansluter till din bank via Open Banking. Det brukar ta 2-3 minuter. Du har väntat i {{elapsedTime}}.',
      },
      analyzing: {
        spinnerLabel: 'Analyserar data...',
        title: 'Vi analyserar dina uppgifter',
        description:
          'Vi går igenom din ekonomi för att ta fram ditt besked. Du har väntat i {{elapsedTime}}.',
      },
      delayed: {
        spinnerLabel: 'Färdigställer besked...',
        title: 'Det tar lite längre än vanligt',
        description:
          'Vi jobbar fortfarande på det. Du behöver inte vänta kvar, vi hör av oss till dig om du blir godkänd. Du har väntat i {{elapsedTime}}.',
      },
      success: {
        title: 'Då var det klart!',
        description: 'Du kommer strax skickas vidare till ditt erbjudande.',
      },
      subDescription: 'Stänger du sidan så hör vi av oss om du blir godkänd.',
      slides: [
        {
          title: 'Du kan ändra när du vill, så ofta du vill',
          description: 'På Mina Sidor kan du ändra månadssumma för återbetalning helt fritt.',
        },
        {
          title: 'Göra extra inbetalningar fritt',
          description: 'Återbetala extra och betala av lånet snabbare.',
        },
        {
          title: 'Du vet väl att alla krediter är röviga?',
          description: 'Tur att du har valt en kredit som vet det och därför jobbar med sig själv.',
        },
        {
          title: 'Blixtsnabba utbetalningar 24/7',
          description: 'Du kan när som helst göra ett uttag och få pengarna direkt till ditt bankkonto.',
        },
        {
          title: 'Världens enda fairnesskvitto',
          description: 'Med Fairlo får du ett kvitto som specar exakt vad som kostar vad.',
        },
        {
          title: 'Sveriges enda schysstcertifierade kredit',
          description: 'Visste du att Fairlo är den enda krediten med B Corp-certifiering?',
        },
        {
          title: 'En stor bank blåste vår grundares mamma',
          description: 'Det var då han kom på idén om en kredit som inte blåste folk.',
        },
        {
          title: 'Visste du att 90% av våra omdömen är femstjärniga?',
          description: 'Vi är sprickstolta över våra omdömen på Trustpilot.',
        },
        {
          title: 'Vår kundtjänst består av mänskliga människor',
          description: 'Oavsett vilket problem du har så kan du få hjälp en riktig människa.',
        },
      ],
    },
    addonProducts: {
      addonProductsForm: {
        title: 'Boosta din kredit med unikt skydd',
        buttonNoProtection: 'Jag vill inte vara skyddad',
        buttonPPISelected: 'Ja, jag vill ha Betalskydd',
        buttonIdProtectSelected: 'Ja, jag vill ha Personskydd',
        buttonAllSelected: 'Ja, jag vill ha fullt skydd',
      },
    },
  },
  DirectPayment: {
    title: 'Betala ditt förfallna belopp med Swish',
    text: 'Beloppet avser följande kostnader:',
    amountToPay: 'Belopp att betala: {{amount, currency}}',
    button: 'Betala med Swish',
    loading: 'Öppna Swish på din mobil och följ instruktionerna',
    underTerminationTitle: 'Ditt konto är under uppsägning men det är inte för sent att undvika inkasso.',
    underTerminationText:
      'Ditt konto är för närvarande nedstängt då du har halkat efter med betalningarna men om du betalar in de förfallna summorna så kommer du snabbt ikapp och får kontot återaktiverat igen.\n\nBeloppet avser följande kostnader:',
    Discount: {
      title: 'En fair deal',
      subtitle: 'Betala {{amountToPay, currency}} så stryker vi {{discount, currency}}',
      text: 'Att halka efter kan hända alla så vi vill hjälpa till, vi tycker att du är värd det. Betala av ditt försenade belopp så stryker vi alla förseningsavgifter och dröjsmålsräntor. Efter att du har betalat kan du använda Fairlo som vanligt igen.',
      discount: 'Förseningskostnader',
      initialAmountToPay: 'Förfallet totalbelopp',
      amountToPayAfterDiscount: 'Kvar att betala',
    },
    ResetPaybackPlan: {
      title: 'En ny start på din kredit',
      text: 'Allt du behöver göra är att betala {{amountToPay, currency}} så får du en ny start utan förfallna fakturor.\n\nDessutom stryker vi inkassoavgifterna och övriga skulder läggs på din kredit.',
      underTerminationTitle: 'Ditt konto är under uppsägning men du har nu en unik chans att få en omstart.',
      underTerminationText:
        'Ditt konto är för närvarande nedstängt då du har halkat efter med betalningarna men nu kan enkelt få en nystart och slippa onödiga kostnader. Vi stryker inkassoavgifter och övriga skulder läggs på din kredit, det enda du behöver göra är att betala {{amountToPay, currency}} idag.',
      table: {
        offer: 'Erbjudande',
        current: 'Ordinarie',
        amountToPay: 'Att betala nu:',
        installmentAmount: 'Månadsbelopp:',
        outstandingAmount: 'Skuld efter betalning:',
      },
      li1: 'Erbjudandet gäller en gång per kund under en begränsad tid',
      li2: 'Inga uttag möjliga på sex månader',
      li3: 'Erbjudandet kostar {{offerCost, currency}}',
      li4: 'Nästa månadsbelopp dras {{date}}',
      payCurrentButton: 'Betala ordinarie',
      payOfferButton: 'Betala erbjudande',
    },
    QRCode: {
      altTitle: 'Swish QR kod',
      title: 'Scanna det här med mobilen',
      step1: 'Starta Swish-appen i mobilen.',
      step2: 'Tryck på Skanna QR',
      step3: 'Rikta kameran mot QR-koden.',
    },
  },
  FairnessReceipt: {
    heading: 'Fairnesskvitto',
    description:
      'En sammanställning av vad du betalar för och hur mycket vi tjänar så att du kan förstå affären fullt ut och se att villkoren är schyssta.',
    withdrawalAmount: 'Summa nytt uttag',
    newTotalBalance: 'Total summa uttag',
    whatYouPay: 'Vad du betalar',
    interest: 'Ränta för {{months}} månader',
    principal: 'Kapitalbelopp',
    setupFee: 'Uppläggningsavgift',
    withdrawalFee: 'Uttagsavgift',
    totalInstallmentFees: 'Månadsavgift för {{months}} månader',
    whatWePay: 'Vad vi betalar',
    funding: 'Finansiering',
    lossProvision: 'Förlustavsättning',
    servicing: 'Servicing',
    labour: 'Personalkostnader',
    totalAmount: 'Total summa',
    whatWeMake: 'Vad vi tjänar',
    done: 'OK',
  },
  ErrorToast: {
    defaultMessage:
      'Det verkar som att något gick fel. Prova gärna igen – om problemet kvarstår kontakta kundservice@fairlo.se',
    transactionDelayed: 'Transaktionen har fördröjts. Vänligen försök igen senare.',
  },
  PaymentProtectionInsurance: {
    insurancePage: {
      title: 'Fairlo Betalskydd',
      description:
        'Fairlo betalskydd betalar dina Fairlo månadskostnader upp till 12 månader om du råkar ut för:',
      li1: 'Ofrivillig arbetslöshet',
      li2: 'Sjukskrivning',
      li3: 'Sjukhusvistelse',
      li4: 'Dödsfall till följd av olycksfall',
      cost: 'Fairlo betalskydd kostar 0,6 % av din utomstående skuld per månad (max 350 kr, minst 30 kr).',
      costExampleTitle: 'Prisexempel',
      costExample: 'För en skuld på 10 000 kr blir kostnaden 60 kr',
      prerequisites: 'Förutsättningar',
      button: 'Godkänn',
      acceptTermsTitle: 'Jag bekräftar att jag tagit del av',
      acceptTerms:
        'premien, uppfyller förutsättningarna (behovsantaganden & teckningskraven) för betalskyddet, samt tagit del av <factSheetLink>produktfaktablad</factSheetLink>, <purchaseInfoLink>för- & efterköpsinformation</purchaseInfoLink>, <mediationInfoLink>information om försäkringsförmedling</mediationInfoLink>, godkänner de <fullTermsLink>fullständiga villkoren för betalskyddet</fullTermsLink> och accepterar att få försäkringsinformationen digitalt.',
    },
  },
  BankId: {
    startBankIdApp: 'Starta BankID appen',
    openBankIdApp: 'Öppna BankID appen',
    openBankIdInAnotherDevice: 'BankID på annan enhet',
    scanQRcode: 'Scanna QR Koden',
    verificationFailed: 'Verifiering med BankID misslyckades',
    retry: 'Försök med BankID igen',
    hintCodeMessages: {
      RFA1: 'Starta BankID-appen.',
      RFA9: 'Skriv in din säkerhetskod i BankID-appen och välj Identifiera eller Skriv under.',
      RFA13: 'Försöker starta BankID-appen.',
      RFA14A:
        'Söker efter BankID, det kan ta en liten stund… Om det har gått några sekunder och inget BankID har hittats har du sannolikt inget BankID som går att använda för den aktuella identifieringen/underskriften i den här enheten. Om du inte har något BankID kan du skaffa ett hos din bank. Om du har ett BankID på en annan enhet kan du starta din BankID-app där.',
      RFA14B:
        'Söker efter BankID, det kan ta en liten stund… Om det har gått några sekunder och inget BankID har hittats har du sannolikt inget BankID som går att använda för den aktuella identifieringen/underskriften i den här datorn. Om du har ett BankID-kort, sätt in det i kortläsaren. Om du inte har något BankID kan du skaffa ett hos din bank.',
      RFA21: 'Identifiering eller underskrift pågår.',
      RFA23: 'Fotografera och läs av din ID-handling med BankID-appen.',
      RFA8: 'BankID-appen svarar inte. Kontrollera att den är startad och att du har internetanslutning. Om du inte har något giltigt BankID kan du skaffa ett hos din bank. Försök sedan igen.',
      RFA16:
        'Det BankID du försöker använda är för gammalt eller spärrat. Använd ett annat BankID eller skaffa ett nytt hos din bank.',
      RFA6: 'Åtgärden avbruten.',
      RFA3: 'Åtgärden avbruten. Försök igen',
      RFA17A:
        'BankID-appen verkar inte finnas i din dator eller mobil. Installera den och skaffa ett BankID hos din bank. Installera appen från din appbutik eller <a class="link" href="https://install.bankid.com" target="_blank" rel="noreferrer">https://install.bankid.com</a>',
      RFA17B:
        'Misslyckades att läsa av QR-koden. Starta BankID-appen och läs av QR-koden. Kontrollera att BankID-appen är uppdaterad. Om du inte har BankID-appen måste du installera den och skaffa ett BankID hos din bank. Installera appen från din appbutik eller <a class="link" href="https://install.bankid.com" target="_blank" rel="noreferrer">https://install.bankid.com</a>.',
      RFA22: 'Okänt fel. Försök igen.',
    },
    errorMessages: {
      RFA4: 'En identifiering eller underskrift pågår redan.',
      RFA22: 'Okänt fel. Försök igen.',
      RFA5: 'Internt tekniskt fel. Försök igen',
    },
  },
  ApplicationExpired: {
    title: 'Erbjudandet har förfallit',
    text: 'Tyvärr har giltighetstiden för detta erbjudande löpt ut. Om du vill kan du ansöka på nytt genom att klicka på knappen nedan.',
    newApplication: 'Gör en ny ansökan',
    backToSite: 'Gå tillbaka till Fairlo.se',
  },
  PartnerApplication: {
    homesafeLandingPage: {
      title: 'Trygg och schysst finansiering i samarbete med Homesafe',
      description:
        'Svara på några korta frågor så ser vi vilka paket från Homesafe som är tillgängliga för dig.',
      li1: 'Snabb kreditbedömning, helt tryggt',
      li2: 'Du väljer ditt paket och signerar',
      li3: 'Inga dolda avgifter, ingen bindningstid',
      li4: 'Lägsta månadskostnad 185 kr',
      eligibilityTitle: 'För att bli godkänd behöver du vara:',
      eligibilityLi1: 'Anställd eller egenföretagare',
      eligibilityLi2: 'Vara mellan 20–75 år',
      eligibilityLi3: 'Inte tidigare kund hos Fairlo',
      eligibilityLi4: 'Inga aktiva betalningsanmärkningar (6 mån) eller skuld hos Kronofogden',
      button: 'Se vilka paket jag kan få',
    },
    homesafeQRcodePage: {
      title: 'Scanna QR koden för att starta ansökan.',
    },
  },
  BrokerApplicationLanding: {
    heading: 'Välkommen till Fairlo! Vi kan erbjuda dig {{amount, currency}}.',
    text: 'Med Fairlo kan du ta ut upp till din kreditgräns när som helst, och betalar endast ränta på det belopp du använder för den tid du använder det.',
    li1: 'Ändra upplägg när du vill, hur ofta du vill',
    li2: 'Du kan alltid ändra månadsbeloppet eller göra extra inbetalningar kostnadsfritt för att sänka lånekostnaden',
    li3: 'Uppläggningsavgift och uttagsavgifter tas från kreditutrymmet',
    addonProductsHeading: 'Boosta din kredit med unikt skydd',
    paymentProtectionInsuranceSelectedButton: 'Ja, jag vill ha Fairlo Betalskydd',
    idProtectSelectedButton: 'Ja, jag vill ha Fairlo Personskydd',
    allAddonProductsSelectedButton: 'Ja, jag vill ha fullt skydd',
    button: 'Fortsätt till signering',
  },
  Transactions: {
    title: 'Betalplan & historik',
    planTab: 'Betalplan',
    historyTab: 'Historik',
    noHistory: 'Det finns ingen historik',
    noPlanNewUser: 'Du har ingen nyttjad kredit',
    noPlan: 'Du har inga kommande betalningar',
    detailsTitle: 'Händelse',
    transaction: {
      type: {
        DEPOSIT: 'Insättning',
        WITHDRAW: 'Uttag',
        PAYBACK: 'Månadsbelopp',
        REFUND: 'Återbetalning',
        SETUP_FEE: 'Uppläggningsavgift',
        ID_PROTECT: 'Personskydd',
      },
      product: {
        CREDIT: 'Varda',
        DEBT_CONSOLIDATION: 'Lösa',
        PAYMENT_PROTECTION_INSURANCE: 'Betalskydd',
        ID_PROTECT: 'Personskydd',
        LOAN: 'Låna',
        LOAN_ID_PROTECT: 'Trygglån',
      },
      status: {
        INCOMPLETE: 'Kommande',
        COMPLETE: 'Betald',
        COMPLETE_DEPOSIT: 'Mottagen',
        COMPLETE_WITHDRAW: 'Utbetald',
        CHARGE: 'Pågående',
        IN_EXTENDED_PAYMENT_PERIOD: 'Utökad betalperiod',
        OVERDUE: 'Förfallen',
        PAYMENT_FREE_MONTH: 'Betalfri månad',
      },
      detailType: {
        PRINCIPAL: 'Kapital',
        INTEREST: 'Ränta',
        OVERDUE_INTEREST: 'Dröjsmålsränta',
        WITHDRAWAL_FEE: 'Uttagsavgift',
        SETUP_FEE: 'Uppläggningsavgift',
        INSTALLMENT_FEE: 'Månadsavgift',
        OVERDUE_FEE: 'Påminnelse',
        DEBT_COLLECTION_FEE: 'Inkassoavgift',
        DIRECT_DEBIT_MISSING_FEE: 'Saknat Autogiro',
        REMIT: 'Efterskänkes',
        UNKNOWN: 'Okänd',
        TERMINATION: 'Uppsägning',
        CAMPAIGN_DISCOUNT: 'Avdragen rabatt',
        COMPOUNDED_PRINCIPAL: 'Obetalda räntor och avgifter',
        CAPITALISED_COST: 'Obetald ränta och avgifter adderad på skuld',
        VAT: 'Moms {{rate}}',
      },
      withoutVat: 'Exkl. Moms',
      withoutVatForDuration: '{{durationInMonths}}m exkl. moms',
      vatRateForDuration: '{{durationInMonths}}m moms {{rate}}',
      feeRemoval: '{{feeType}} åter',
      dueDate: 'Förfallodatum',
      completionDate: 'Betaldatum',
      statusTitle: 'Status',
      totalAmount: 'Total belopp',
    },
  },
  Maintenance: {
    title: 'Ursäkta röran!',
    text1: 'Fairlos hemsida är nere för underhåll.',
    text2: 'Vi uppdaterar vår databas och är tillbaka inom kort.',
  },
  MoneezyBanner: {
    title: 'Vi rekommenderar att du testar hos vår partner Moneezy.',
    button: 'Ja, ta mig till Moneezy',
    disclaimer:
      'Fairlo får kommission för eventuella affärer som du gör med Moneezy. Vi delar ingen data om dig.',
  },
  Plus1Banner: {
    title: 'Vi rekommenderar att du testar hos vår partner Plus1.',
    button: 'Gå vidare',
    disclaimer:
      'Fairlo får kommission för eventuella affärer som du gör med Plus1. Vi delar ingen data om dig.',
  },
  CreditTierSummary: {
    title: 'Avgifter, räntor och återbetalningar',
    creditLimit: 'Låneutrymme',
    interestRate: 'Ränta',
    installmentAmount: 'Månadsbelopp',
    totalCost: 'Totalt',
    fees: {
      title: 'Avgifter',
      setupFee: 'Uppläggningsavgift',
      withdrawalFee: 'Uttagsavgift',
      installmentFee: 'Månadsavgift',
      directDebitMissingFee: 'Utan autogiro',
      upTo: 'upp till {{amount, currency}}',
      upToPerMonth: 'upp till {{amount, currency}}/mån',
      perMonth: '{{amount, currency}}/mån',
    },
  },
  IdProtectSignup: {
    title: 'Unikt skydd mot bedrägeri, identitetsstöld och hackers',
    text: 'Tjänsten bevakar ditt digitala avtryck i email, kortuppgifter, pass med mera samt säkerställer att du ligger steget före potentiella hot.',
    li1: '<b>Försäkring</b> som skyddar mot förlust, juridisk hjälp (upp till 1,34 mkr), ID-stöld, SIM-kortsintrång, köp, onlinetrakasserier och psykologstöd.',
    li2: '<b>Realtidsbevakning</b> av email, telefon, betalkort, kreditinformation, myndighetsdata, pass, ID-kort, körkort med mera.',
    li3: '<b>Supportnummer</b> och andra användbara funktioner som till exempel kreditspärr som förhindrar obehöriga kreditansökningar.',
    price: 'Endast {{amount, currency}}/m',
    priceDisclaimer: 'Avsluta när du vill',
    viewTerms: 'Här kan du läsa det finstilta',
    acceptCheckboxLabel: 'Ja, ge mig skydd',
    signupDisclaimer:
      'Genom att klicka “Ja, jag vill ha Fairlo Personskydd” så accepterar du avtalsvillkor för <terms>Fairlo Personskydd</terms>',
    button: 'Ja, jag vill ha Fairlo Personskydd',
  },
  IdProtectProduct: {
    title: 'Fairlo Personskydd',
    cardTitle: 'Du är skyddad',
    nextRepaymentAmount: 'Månadsbelopp',
    prepaid: 'Förbetalt',
    nextRepaymentDate: 'Nästa dragning',
    cancelledCardTitle: 'Återaktivera ditt skydd',
    cancelledCardText:
      'Du har avslutat ditt skydd, och det kommer att upphöra den {{date, datetime(month: short; day: numeric)}}',
    li1: '<b>Försäkring</b> som skyddar mot förlust, juridisk hjälp (upp till 1,34 mkr), ID-stöld, SIM-kortsintrång, köp, onlinetrakasserier och psykologstöd.',
    li2: '<b>Realtidsbevakning</b> av email, telefon, betalkort, kreditinformation, myndighetsdata, pass, ID-kort, körkort med mera.',
    li3: '<b>Supportnummer</b> och andra användbara funktioner som till exempel kreditspärr som förhindrar obehöriga kreditansökningar.',
    termsButton: 'Läs mer',
    portalButton: 'Mitt Personskydd',
    reactivateButton: 'Återaktivera igen',
  },
  PaymentProtectionInsuranceProduct: {
    title: 'Fairlo Betalskydd',
    cardTitle: 'Dina betalningar är skyddade',
    nextRepaymentAmount: 'Månadsbelopp',
    nextRepaymentDate: 'Nästa dragning',
    cancelledCardTitle: 'Återaktivera ditt skydd',
    cancelledCardText:
      'Du har avslutat ditt skydd, och det kommer att upphöra den {{date, datetime(month: short; day: numeric)}}',
    text: 'Betalskyddet täcker vid:',
    li1: 'Ofrivillig arbetslöshet',
    li2: 'Sjukskrivning',
    li3: 'Sjukhusvistelse',
    li4: 'Dödsfall till följd av olycksfall',
    termsButton: 'Läs mer',
    claimButton: 'Göra ett krav',
    reactivateButton: 'Återaktivera igen',
  },
  HomesafePartnerOffer: {
    heading: 'Du har blivit godkänd, välj ditt paket nedan.',
    installmentFilterLabel: 'Välj antal månader',
    installmentFilterOption: '{{months}} mån',
    monthlyPayment: '{{amount, currency}}/mån i {{numberOfInstallments}} mån',
    loanAmount: 'Larmpaket: {{amount, currency}}',
    totalCost: 'Totalt att betala: {{amount, currency}}',
    BASE: {
      title: 'HomeSafe Base Paket',
      button: 'Gå vidare med Base Paket',
      features: [
        'Allt du behöver för ett grundläggande hemskydd',
        'Skyddar dörrar, fönster och rörelse direkt',
        'Enkel att installera och använda',
      ],
    },
    PLUS: {
      title: 'HomeSafe Plus Paket',
      button: 'Gå vidare med Plus Paket',
      features: [
        'Fler sensorer för bättre täckning i hela hemmet',
        'Inbyggd kamera för extra kontroll och trygghet',
        'Perfekt för större bostäder',
      ],
    },
    PREMIUM: {
      title: 'HomeSafe Premium Paket',
      button: 'Gå vidare med Premium Paket',
      features: [
        'Maxat paket med full täckning i hela hemmet',
        'Flest sensorer + kamera för högsta säkerhet',
        'För dig som vill ha full kontroll, dygnet runt',
      ],
    },
  },
  HomesafeSelectedProduct: {
    heading: 'Sammanfattning',
    text: 'Nedan ser du din sammanfattning. Glöm inte att med Fairlo kan du alltid betala av lånet när du vill, och spara pengar.',
    packageLabel: {
      BASE: 'HomeSafe Base Paket:',
      PLUS: 'HomeSafe Plus Paket:',
      PREMIUM: 'HomeSafe Premium Paket:',
    },
    feesLabel: 'Avgifter:',
    feesValue: '<s>{{originalAmount, currency}}</s> {{amount, currency}}',
    interestRateLabel: 'Ränta:',
    effectiveInterestRateLabel: 'Effektiv ränta:',
    monthlyAmountLabel: 'Månadsbelopp:',
    monthlyAmountValue: '{{amount, currency}} i {{numberOfInstallments}} mån',
    totalCostLabel: 'Totalt att betala:',
    totalCostDisclaimer:
      'Betalar du av snabbare så går kostnaden ner. Du kan betala av hela lånet när du vill',
    signupDisclaimer:
      'Jag godkänner <loanAgreement>Kreditavtalet,</loanAgreement> <terms>Allmänna villkor,</terms> <sekki>SEKKI,</sekki> <privacyPolicy>Integritetspolicy</privacyPolicy> och <directDebitTerms>Autogiromedgivande</directDebitTerms>.',
    button: 'Betala med Fairlo',
  },
  LoanOffer: {
    heading: 'Just nu kan vi erbjuda dig ett lån på {{amount, currency}}.',
    text: 'Du ansökte om en kontokredit. Baserat på din ansökan kan vi istället erbjuda dig ett lån - vilket ger dig hela summan direkt, med tydliga återbetalningsvillkor.',
    interestRateLabel: 'Ränta:',
    payoutAmountLabel: 'Överförs till ditt konto:',
    setupFeeLabel: 'Uppläggningsavgift:',
    payoutAmountLabel2: 'Lån:',
    installmentFeeLabel: 'Månadsavgift:',
    installmentAmountLabel: 'Månadsbelopp:',
    installmentAmountDisclaimer: '(Inkluderar alla kostnader)',
    totalCostLabel: 'Kostnad för lån:',
    totalCostDisclaimer: '(Baserad på {{numberOfInstallments}} mån)',
    signupDisclaimer:
      'Jag godkänner <loanAgreement>Kreditavtalet,</loanAgreement> <terms>Allmänna villkor,</terms> <sekki>SEKKI,</sekki> <privacyPolicy>Integritetspolicy</privacyPolicy> och Autogiromedgivande',
    button: 'Signera kreditavtalet',
    declineButton: 'Nej, jag vill inte ha ett lån',
  },
  LoanIdProtectOffer: {
    heading: 'Vi kan erbjuda dig räntefria Trygglånet och betala ut {{amount, currency}}.',
    description:
      'Du ansökte om en kontokredit. Baserat på din ansökan kan vi istället erbjuda dig ett Fairlo Trygglån som kombinerar ett räntefritt lån med en försäkring och brett skydd mot bedrägeri.',
    loanIdProtectSectionTitle: 'Trygglån, vad ingår?',
    loanIdProtectBenefit1: '{{amount, currency}} utbetalt lånebelopp till ditt konto',
    loanIdProtectBenefit2: 'Person och ID skydd',
    loanIdProtectBenefit3: 'Bred försäkring och omfattande bevakning',
    moreAboutLoanIdProtect: 'Mer om Personskydd',
    totalLoanAmountLabel: 'Total lånebelopp',
    payoutAmountLabel: 'Utbetalt lånebelopp',
    idProtectLabel: 'Personskydd {{months}} mån',
    idProtectValue: '<s>{{originalPrice, currency}}</s> {{actualPrice, currency}}',
    setupFeeLabel: 'Uppläggningsavgift',
    interestRateLabel: 'Ränta {{rate, percent}}',
    monthlyFeeLabel: 'Månadsavgift',
    monthlyCostsTitle: 'Månadskostnader',
    monthlyAmountTitle: 'Månadsbelopp:',
    totalRepaymentText:
      'Totalt att återbetala {{total, currency}} baserat på {{months}} månader, betalar du av snabbare så minskar kostnaden.',
    signupDisclaimer:
      'Jag godkänner <loanIdProtectAgreement>Trygglåneavtalet,</loanIdProtectAgreement> <terms>Trygglån villkor,</terms> <idProtectTerms>Personskydd villkor,</idProtectTerms> <sekki>SEKKI</sekki> och Autogiromedgivande.',
    declineButton: 'Nej, jag vill inte ha Trygglån',
    button: 'Signera Trygglåneavtalet',
  },
  SignSuccess: {
    title: 'Nästan klart, anslut bankkontot du vill få in pengar på.',
    body: 'Nu är allt signerat och klart. I nästa steg kopplar du på ditt bankkonto.\n\nKlicka på knappen nedanför för att gå vidare.',
    button: 'Anslut ett bankkonto',
  },
  PartnerSignSuccess: {
    heading: 'Signerat! Nu behöver du bara ansluta autogiro.',
    body: 'I nästa steg väljer du din bank och kopplar på ditt bankkonto som du vill betala ifrån.',
    button: 'Anslut bankkonto',
  },
  PartnerSelectAccount: {
    success: {
      heading: 'Nu är ditt köp med Fairlo klart!',
      text: 'Slutför med din Homesafe representant. Vi har skickat ett mail till dig med all information.',
      firstPaymentLabel: 'Första betalning:',
      firstPaymentValue: '{{amount, currency}} {{chargeDate, datetime(month: short; day: numeric)}}',
      paymentMethodLabel: 'Betalningsmetod:',
      paymentMethodValue: 'Autogiro',
      description:
        'Från och med nu kan du logga in på Mina Sidor och hantera din avbetalningsplan med full flexibilitet.',
      button: 'Mina Sidor',
    },
  },
  Loan: {
    LOAN: { title: 'Fairlo Låna' },
    LOAN_ID_PROTECT: { title: 'Fairlo Trygglån' },
    LOAN_PARTNER: { title: 'Ditt köp med Homesafe' },
    cards: {
      // TODO(EC-1004): Remove once newProductHomepage is fully rolled out
      loanWithdrawalFailed: {
        title: 'Något gick fel så vi lyckades inte betala ut pengarna.',
        body: 'Om problemet kvarstår, vänligen kontakta kundtjänst på kundservice@fairlo.se',
      },
    },
  },
  ProductSummaryCard: {
    availableLimit: 'Tillgänglig kredit',
    outstandingBalance: 'Återstående saldo',
    creditLimit: 'Låneutrymme',
    used: 'Nyttjat',
    monthlyAmountLabel: 'Månadsbelopp',
    monthlyAmountValuePositive: '{{amount, currency}} i {{period}} mån',
    interestRate: 'Ränta',
  },
  RepaymentSummaryCard: {
    product: {
      CREDIT: 'Varda',
      DEBT_CONSOLIDATION: 'Lösa',
      LOAN: 'Låna',
      PAYMENT_PROTECTION_INSURANCE: 'Betalskydd',
      ID_PROTECT: 'Personskydd',
      LOAN_ID_PROTECT: 'Trygglån',
    },
    nextRepayment: 'Nästa dragning',
    currentRepayment: 'Nuvarande dragning',
    ongoing: 'pågående',
    nextRepaymentDate: 'den {{date, datetime(month: short; day: numeric)}}',
  },
  GenericCreditOffer: {
    title: 'Ditt erbjudande om {{amount, currency}} från Fairlo är klart, bra va?',
    text: 'Nu är det bara ett steg kvar. Ta en stund att se över din personliga sammanställning nedan. När du känner dig redo signerar du enkelt och tryggt med BankID.',
    creditLimitLabel: 'Låneutrymme:',
    interestRateLabel: 'Ränta:',
    setupFeeLabel: 'Uppläggningsavgift:',
    withdrawalFeeLabel: 'Uttagsavgift (ord. pris {{amount, currency}}):',
    installmentFeeLabel: 'Månadsavgift:',
    addonProductsHeading: 'Tilläggstjänster:',
    idProtectLabel: 'Fairlo Personskydd:',
    idProtectCost: '{{amount, currency}} / månad',
    paymentProtectionInsuranceLabel: 'Fairlo Betalskydd:',
    paymentProtectionInsuranceCost: '{{cost}} / månad',
    totalCostLabel: 'Total kostnad:',
    monthlyAmountLabel: 'Månadsbelopp:',
    monthlyAmountValue: '{{amount, currency}} / mån',
    totalCostDisclaimer:
      '(Ex. baserat på {{numberOfInstallments}} mån avbetalningstid, du kan alltid betala av lånet snabbare genom att öka ditt månadsbelopp)',
    signupDisclaimer:
      'Jag godkänner <creditAgreement>Kreditavtalet,</creditAgreement> <terms>Allmänna villkor,</terms> <sekki>SEKKI,</sekki> <privacyPolicy>Integritetspolicy</privacyPolicy> och <directDebitTerms>Autogiromedgivande</directDebitTerms>.',
    declineButton: 'Inte just nu',
    button: 'Signera kreditavtalet',
  },
  GenericDeclineOffer: {
    title: 'Inga problem, erbjudandet väntar på dig',
    body: 'Ditt erbjudande är giltigt i 7 dagar. Vi hör av oss så att du enkelt kan hitta tillbaka om du ändrar dig.',
    leadIn: 'Vill du berätta varför erbjudandet inte passade dig? Det hjälper oss att bli bättre.',
    reason_CREDIT_LIMIT_TOO_LOW: 'För låg kreditgräns',
    reason_INTEREST_RATE_TOO_HIGH: 'För hög ränta',
    reason_FEES_TOO_HIGH: 'För höga avgifter',
    reason_TOTAL_MONTHLY_COST_TOO_HIGH: 'För hög total månadskostnad',
    reason_TOTAL_COST_OF_CREDIT_TOO_HIGH: 'För hög total lånekostnad',
    reason_TERMS_UNCLEAR: 'För otydliga villkor',
    reason_BETTER_OFFER_ELSEWHERE: 'Fick ett annat bättre erbjudande',
    reason_OTHER: 'Annat',
    freeTextLabel: 'Fritext (valfritt)',
    sendFeedback: 'Skicka feedback',
    skip: 'Hoppa över',
  },
  OpenBankingDataNotProcessedCard: {
    title: 'Kunde inte hämta bankdata',
    body: 'Tyvärr kunde vi inte hämta din bankdata idag. Ditt erbjudande är därför baserat på en helt vanlig kreditupplysning.',
  },
  OpenBankingDataNotProcessedPage: {
    title: 'Varför kunde vi inte hämta din bankdata?',
    description:
      'Vi stötte på ett tillfälligt hinder när vi försökte koppla upp oss mot din bank via vår partner Kreditz. Det innebär att vi just nu inte kan se de transaktioner som behövs för att gå vidare.',
    reasonsHeading: 'Detta beror oftast på något av följande:',
    reason1:
      'Tidsgränsen överskreds: Kopplingen tog lite längre tid än väntat och processen avbröts automatiskt av säkerhetsskäl.',
    reason2: 'Kontaktproblem: Vi tappade tillfälligt kontakten med leverantören som hanterar datadelningen.',
    reason3: 'Underhåll hos din bank: Din bank kan ha tekniska störningar eller utför service just nu.',
    reason4:
      'Avbruten signering: Om BankID-signeringen inte genomfördes tillräckligt snabbt kan processen ha nollställts.',
    whatToDoHeading: 'Vad kan du göra nu?',
    whatToDoText:
      'I de allra flesta fall är detta tillfälligt. Om du vill försöka igen med att hämta din bankdata, behöver du gå igenom ansökningsprocessen på nytt.',
    button: 'Ta mig tillbaka',
  },
  LoanPartnerSummaryCard: {
    currentDebt: 'Nuvarande skuld',
    HomesafePackageLabel: {
      BASE: 'HomeSafe Base Paket',
      PLUS: 'HomeSafe Plus Paket',
      PREMIUM: 'HomeSafe Premium Paket',
    },
    interestRate: 'Ränta',
    monthlyAmountLabel: 'Månadsbelopp',
    monthlyAmountValuePositive: '{{amount, currency}} i {{period}} mån',
  },
  ProductHomeShortcuts: {
    title: 'Genvägar',
    debtConsolidationTitle: 'Fairlo Lösa',
    debtConsolidationSubtitle: 'All information gällande ditt "Lösa" lån hos oss',
    idProtectActiveTitle: 'Personskydd',
    idProtectActiveSubtitle: 'Hantera ditt Personskydd',
    idProtectInactiveTitle: 'Skaffa Personskydd',
    idProtectInactiveSubtitle: 'Skydda dig mot id-bedrägerier',
    ppiActiveTitle: 'Betalskydd',
    ppiActiveSubtitle: 'Hantera ditt Betalskydd',
    ppiInactiveTitle: 'Skaffa Betalskydd',
    ppiInactiveSubtitle: 'Skydd om något oväntat händer',
    transactionsTitle: 'Transaktionshistorik',
    transactionsSubtitle: 'Alla in- och utbetalningar med detaljer',
  },
  CreditHome: {
    title: 'Hej <private>{{username}}</private>!',
    availableAmount: 'Du kan ta ut',
    outOfCreditLimit: 'av {{amount, currency}}',
    amountUsed: 'Nyttjat belopp: {{amount, currency(displayDecimals: false)}}',
    amountUsedPrefix: 'Nyttjat belopp: ',
    withdraw: 'Ta ut pengar',
    deposit: 'Betala in',
  },
  LoanHome: {
    title: 'Hej <private>{{username}}</private>!',
    loanPartnerTitle: 'Ditt köp med Homesafe',
    remainingToPay: 'Kvar att betala',
    outOfLoanAmount: 'av {{amount, currency}}',
    amountRepaid: 'Du har betalt: {{amount, currency(displayDecimals: false)}}',
    amountRepaidPrefix: 'Du har betalt: ',
    deposit: 'Betala in',
  },
  Notifications: {
    overdue: {
      title: 'Förfallet belopp.',
      description: 'Betala {{amount, currency}} för att undvika fler kostnader och återaktivera din kredit.',
    },
    paymentFreeMonth: {
      title: 'Betalfri månad använt.',
      description: 'Din kredit är stängd t.o.m din nästa månadsbetalning.',
      descriptionWithDate: 'Din kredit är stängd t.o.m {{date}}.',
    },
    paymentProviderMigration: {
      title: 'Anslut ditt konto.',
      description: 'Vi har en ny betalleverantör och du behöver koppla ditt bankkonto på nytt.',
    },
    noDirectDebit: {
      title: 'Autogiro saknas.',
      description: 'Anslut ett bankkonto nu och undvik en avgift på {{amount, currency}} på nästa faktura.',
    },
    noBankAccount: {
      title: 'Bankkonto saknas.',
      description: 'Klicka här för att ansluta ett bankkonto och aktivera din kredit igen.',
    },
    directDebitMandateInProgress: {
      title: 'Autogiro läggs upp.',
      description: 'Det kan ibland ta några bankdagar att aktivera.',
    },
    idProtectActivationNeeded: {
      title: 'Aktivera Personskydd.',
      description: 'Slutför konfigureringen av ditt skydd för att aktivera det.',
    },
    transactionPending: {
      title: 'Transaktion pågår.',
      description: 'Vänta några minuter innan du gör nya uttag eller insättningar.',
    },
    transactionDelayed: {
      title: 'Kontakt med banken dröjer.',
      description: 'Försök igen om 30 minuter.',
    },
    loanWithdrawalFailed: {
      title: 'Utbetalningen misslyckades.',
      description: 'Kontakta kundservice@fairlo.se om problemet kvarstår.',
    },
  },
  Promotions: {
    levla: {
      label: 'Rekommenderad',
      title: 'Höj din kreditgräns och få lägre ränta',
      description: 'Du har goda chanser att bli beviljad. Ansökan tar en minut och ger ingen UC-förfrågan.',
    },
    resetOverdue: {
      label: 'Erbjudande',
      title: 'Stryk dina skulder och börja om på nytt!',
      description:
        'Du har ett unikt erbjudande gällande din förfallna faktura, klicka här för att ta del av erbjudandet.',
    },
    discountOverdue: {
      label: 'Erbjudande',
      title: 'Vi bjuder på förseningsavgiften!',
      description: 'Betala av ditt försenade belopp så stryker vi alla förseningsavgifter.',
    },
    paymentProtectionInsurance: {
      label: 'Erbjudande',
      title: 'Du saknar just nu Betalskydd',
      description:
        'Blir du sjukskriven eller ofrivilligt arbetslös betalar vi ditt Fairlo-månadsbelopp i upp till 12 månader.',
    },
    idProtect: {
      label: 'Erbjudande',
      title: 'Vill du skydda din identitet?',
      description:
        'Med Fairlo Personskydd får du bevakning av personnummer, pass och kort. Ett samtal spärrar allt om något händer.',
    },
    idProtectCampaign: {
      label: 'Erbjudande',
      title: 'Gratis Personskydd i 2 månader?',
      description: 'Bevakning av personnummer, pass och kort. Ett samtal spärrar allt om något händer.',
    },
  },
  RepaymentCard: {
    toggleNextPaymentDetails: 'Växla detaljer för nästa betalning',
    nextRepayment: 'Nästa betalning: {{date, datetime(month: short; day: numeric)}}',
    debtFreeIn: 'Skuldfri om ca {{count}} mån',
    changeMonthlyPaymentButtonShort: 'Ändra',
    leftToPay: 'Kvar att betala: ca {{amount, currency}}',
    basedOnCurrentRepaymentPlan: '(Baserat på nuvarande betalningsplan)',
    paymentPlanButton: 'Visa hela min betalningsplan',
    changeMonthlyPaymentButton: 'Ändra mitt månadsbelopp',
    interest: '{{label}} ({{rate}})',
    principal: 'Betala ner skuld',
  },
} as const;

export default swedish;
